<template>
  <div>
    <section class="page-title contrato pf-title">
      <div class="center">
        <router-link to="/pessoafisica" class="back-button fas fa-angle-left"></router-link>
        <p class="label-planos">Pessoa Física</p>
        <h1 class="the-title">Contrato</h1>
      </div>
    </section>

    <section class="page-content center planos-form">
      <div class="plano-selecionado" style="background: #f1f1f1;"><span>{{this.planoSelecionado.name}} - {{this.planoSelecionado.registro}} - R$ {{this.planoSelecionado.value}} (por pessoa) - {{this.planoSelecionado.cobertura}}</span></div>
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">Primeiro Acesso</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2" :editable="editPassos" >Dados Pessoais</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 3" step="3" :editable="editPassos">Anexos</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 4" step="4" :editable="editPassos">Endereço</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 5" step="5" :editable="editPassos">Beneficiários</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="6" :editable="editPassos">Contratar o Plano</v-stepper-step>
        </v-stepper-header>
        
        <v-stepper-items>
          <!-- PASSO 1 -->
          <v-stepper-content step="1">
            <v-container grid-list-md>
              <v-card class="mb-5" min-height="200px" flat>   
                <v-layout row wrap>
                  <v-flex xs12 sm12 lg12>
                    <v-alert type="info" :value="true" style="border-radius: 10px; font-size: 15px">ATENÇÃO: confira atentamente o cadastro de e-mail e celular/WhatsApp. Os dados do seu plano poderão ser encaminhados através destes canais de comunicação.</v-alert>
                    <br>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>      
                    <v-text-field
                      v-model="financialManagers.cpf"
                      label="CPF*"
                      v-validate="'required|cpf'"
                      :error-messages="errors.collect('cpf')"
                      return-masked-value mask="###.###.###-##"
                      data-vv-name="cpf"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg5>      
                    <v-text-field
                      v-model="financialManagers.email"
                      v-validate="'required|email'"
                      :error-messages="errors.collect('email')"
                      label="E-mail*"
                      data-vv-name="email"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg2>
                    <v-text-field
                      v-model="financialManagers.password"
                      label="Senha*"
                      v-validate="'required'"
                      :error-messages="errors.collect('senha')"
                      type="password"
                      ref="password"
                      data-vv-name="senha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg2>
                    <v-text-field
                      v-model="financialManagers.confirmPassword"
                      label="Repetir Senha*"
                      type="password"
                      :error-messages="errors.collect('password')"
                      v-validate="'required|confirmed:password'"
                      data-vv-name="password"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg9>
                    <v-text-field
                      v-model="financialManagers.firstName"
                      label="Nome Completo*"
                      box
                      v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                      :error-messages="errors.collect('firstName')"
                      data-vv-name="firstName"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>
                    <v-text-field
                      v-model="financialManagers.cellPhone"
                      label="WhatsApp com DDD*"
                      return-masked-value mask="(##)#####-####"
                      v-validate="'required'"   
                      :error-messages="errors.collect('Celular')"
                      data-vv-name="Celular"
                      box
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs12 sm12 lg3>      
                    <v-select
                      box               
                      v-model="financialManagers.state"
                      :items="estados"
                      item-text="prefix"
                      item-value="codeS4"
                      label="UF*"
                      v-validate="'required'"
                      :error-messages="errors.collect('uf')"
                      data-vv-name="uf"
                    ></v-select>
                  </v-flex> -->
                </v-layout>
              </v-card>     
              <v-btn style="border-radius: 8px;" large dark color="#8395A7" @click="salvarPrimeiroAcesso()">Continuar</v-btn>
            </v-container>
          </v-stepper-content>
          <!-- FIM DO PASSO 1 -->

          <!-- PASSO 2 -->
          <v-stepper-content step="2">
            <v-container grid-list-md>
              <v-card class="mb-5" min-height="200px" flat>
                <v-layout row wrap>
                  <v-flex xs12 sm12 lg8>
                    <v-text-field
                      disabled
                      v-model="financialManagers.firstName"
                      label="Nome Completo"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>      
                    <v-select
                      v-model="financialManagers.gender"
                      label="Sexo*"
                      v-validate="'required'"
                      :error-messages="errors.collect('gender')"
                      data-vv-name="gender"
                      :items="generos"
                      item-text="text"
                      item-value="value"
                      box
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="dataNasc"
                      label="Data de Nascimento*"
                      v-validate="'required|date_format:dd/MM/yyyy'"
                      :error-messages="errors.collect('dateOfBirth')"
                      return-masked-value mask="##/##/####"
                      data-vv-name="dateOfBirth"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-select
                      v-model="financialManagers.maritalStatus"
                      label="Estado Civil*"
                      v-validate="'required'"
                      :error-messages="errors.collect('maritalStatus')"
                      data-vv-name="maritalStatus"
                      :items="estadoscivil"
                      item-text="text"
                      item-value="value"
                      box
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="financialManagers.cpf"
                      label="CPF"
                      disabled
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>      
                    <v-text-field
                      v-model="financialManagers.susNumber"
                      label="CNS (Cartão do SUS)"
                      v-validate="'cns'"
                      :error-messages="errors.collect('cns')"
                      data-vv-name="cns"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="financialManagers.rg"
                      label="RG*"
                      v-validate="'required'"
                      :error-messages="errors.collect('rg')"
                      data-vv-name="rg"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="financialManagers.rgEmitter"
                      label="Órgão Expedidor*"
                      v-validate="'required'"
                      :error-messages="errors.collect('rgEmissor')"
                      data-vv-name="rgEmissor"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg6>      
                    <v-text-field
                      v-model="financialManagers.motherName"
                      label="Nome da Mãe*"
                      v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                      :error-messages="errors.collect('motherName')"
                      data-vv-name="motherName"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg6>      
                    <v-text-field
                      v-model="financialManagers.email"
                      label="E-mail"
                      box
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg6>      
                    <v-text-field
                      v-model="financialManagers.homePhone"
                      return-masked-value mask="(##)####-####"
                      label="Telefone Fixo"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg6>      
                    <v-text-field
                      v-model="financialManagers.cellPhone"
                      label="WhatsApp com DDD*"
                      return-masked-value mask="(##)#####-####"
                      disabled
                      box
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs12 sm12 lg4>      
                    <v-text-field
                      v-model="financialManagers.cellPhone2"
                      label="Whatsapp"
                      return-masked-value mask="(##)#####-####"
                      box
                    ></v-text-field>
                  </v-flex> -->
                  <v-flex xs12 sm12 lg12>            
                    <v-radio-group v-model="financialManagers.contratanteTitular" row :disabled="!radioBTtitular">
                      <strong style="font-weight: bold;">O contratante será o beneficiário titular do plano? &nbsp;&nbsp;</strong>
                      <v-radio color="#8395A7" label="Sim" :value="true"></v-radio>
                      <v-radio color="#8395A7" label="Não" :value="false"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-card>
              <v-btn style="border-radius: 8px;" large dark color="#8395A7" @click="avancaPasso3()">Continuar</v-btn>
              <v-btn style="border-radius: 8px; width: 250px;" large dark @click="salvarContinuar()" color="blue-grey darken-1">Salvar e continuar depois</v-btn>
            </v-container>
          </v-stepper-content>
          <!-- FIM DO PASSO 2 -->

          <!-- PASSO 3 -->
          <v-stepper-content step="3">
            <v-container grid-list-md>
              <v-card class="mb-5" min-height="200px" flat>
                <v-layout row wrap>
                  <!-- RG1 -->
                  <v-flex xs12 sm12 lg3>
                    <file-upload
                      class="btn btn-primary"
                      input-id="file1"
                      extensions="pdf,gif,jpg,jpeg,png,webp"
                      accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                      post-action="/upload/post"
                      v-model="filesRg1"
                      @input-filter="inputFilter"
                      @input-file="inputFileRg1"
                      ref="upload1"
                    >
                      <p class="form-titulo" style="font-size: 20px">RG (FRENTE)</p>
                      <v-btn style="border-radius: 8px;" large dark color="#8395A7">Selecionar arquivo</v-btn> 
                      <p id="rg1" value="" hidden></p>
                      <p v-if="filesRg1 == ''">Nenhum arquivo selecionado</p>
                      <div v-else>                    
                        <p v-for="(file) in filesRg1" :key="file.id">{{file.name}}</p>
                      </div>              
                    </file-upload>              
                  </v-flex>

                  <!-- RG2 --> 
                  <v-flex xs12 sm12 lg3>
                    <file-upload
                      class="btn btn-primary"
                      input-id="file2"
                      extensions="pdf,gif,jpg,jpeg,png,webp"
                      accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                      post-action="/upload/post"
                      v-model="filesRg2"
                      @input-filter="inputFilter"
                      @input-file="inputFileRg2"
                      ref="upload2"
                    >
                      <p class="form-titulo" style="font-size: 20px">RG (VERSO)</p>
                      <v-btn style="border-radius: 8px;" large dark color="#8395A7">Selecionar arquivo</v-btn>  
                      <p id="rg2" value="" hidden></p>
                      <p v-if="filesRg2 == ''">Nenhum arquivo selecionado</p>
                      <div v-else>                    
                        <p v-for="(file) in filesRg2" :key="file.id">{{file.name}}</p>
                      </div>              
                    </file-upload>                        
                  </v-flex>

                  <!-- CPF --> 
                  <v-flex xs12 sm12 lg3>
                    <file-upload
                      class="btn btn-primary"
                      input-id="file3"
                      extensions="pdf,gif,jpg,jpeg,png,webp"
                      accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                      post-action="/upload/post"
                      v-model="filesCPF"
                      @input-filter="inputFilter"
                      @input-file="inputFileCPF"
                      ref="upload3"
                    >
                      <p class="form-titulo" style="font-size: 20px">CPF</p>
                      <v-btn style="border-radius: 8px;" large dark color="#8395A7">Selecionar arquivo</v-btn>
                      <p id="cpf" value="" hidden></p>
                      <p v-if="filesCPF == ''">Nenhum arquivo selecionado</p>
                      <div v-else>                    
                        <p v-for="(file) in filesCPF" :key="file.id">{{file.name}}</p>
                      </div>              
                    </file-upload>                        
                  </v-flex>

                  <!-- ENDEREÇO --> 
                  <v-flex xs12 sm12 lg3>    
                    <file-upload
                      class="btn btn-primary"
                      input-id="file4"
                      extensions="pdf,gif,jpg,jpeg,png,webp"
                      accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                      post-action="/upload/post"
                      v-model="filesAddress"
                      @input-filter="inputFilter"
                      @input-file="inputFileAddress"
                      ref="upload4"
                    >
                      <p class="form-titulo" style="font-size: 20px">Comp. de Endereço</p>
                      <v-btn style="border-radius: 8px;" large dark color="#8395A7">Selecionar arquivo</v-btn>
                      <p id="address" value="" hidden></p>
                      <p v-if="filesAddress == ''">Nenhum arquivo selecionado</p>
                      <div v-else>
                        <p v-for="(file) in filesAddress" :key="file.id">{{file.name}}</p>
                      </div>
                    </file-upload>
                  </v-flex>

                  <!-- OUTROS --> 
                  <v-flex xs12 sm12 lg3>    
                    <file-upload
                      class="btn btn-primary"
                      input-id="file5"
                      extensions="pdf,gif,jpg,jpeg,png,webp"
                      accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                      post-action="/upload/post"
                      v-model="filesOutros"
                      @input-filter="inputFilter"
                      @input-file="inputFileOutros"
                      ref="upload5"
                    >
                      <p class="form-titulo" style="font-size: 20px">Outros</p>
                      <v-btn style="border-radius: 8px;" large dark color="#8395A7">Selecionar arquivo</v-btn>  
                      <p id="outros" value="" hidden></p>
                      <p v-if="filesOutros == ''">Nenhum arquivo selecionado</p>
                      <div v-else>
                        <p v-for="(file) in filesOutros" :key="file.id">{{file.name}}</p>
                      </div>
                    </file-upload>                        
                  </v-flex>
                </v-layout>
              </v-card>
              <v-btn style="border-radius: 8px;" large dark color="#8395A7" @click="avancaPasso4()">Continuar</v-btn>
              <v-btn style="border-radius: 8px; width: 250px;" large dark color="blue-grey darken-1" @click="salvarContinuar()">Salvar e continuar depois</v-btn>
            </v-container>
          </v-stepper-content>
          <!-- FIM DO PASSO 3 -->

          <!-- PASSO 4 --> 
          <v-stepper-content step="4">
            <v-container grid-list-md>
              <v-card class="mb-5" min-height="200px" flat>
                <v-layout row wrap>
                  <v-flex xs12 sm12 lg4>
                    <v-text-field
                      v-model="financialManagers.cep"
                      label="CEP*"
                      return-masked-value mask="#####-###"
                      v-validate="'required'"
                      :error-messages="errors.collect('cep')"
                      data-vv-name="cep"
                      @blur="retornoCEP()"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg9>      
                    <v-text-field
                      v-model="financialManagers.address"
                      label="Rua"
                      box
                      :disabled="editaRua"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>    
                    <v-text-field
                      v-model="financialManagers.addressNumber"
                      label="Número*"
                      type="number"
                      v-validate="'required'"
                      :error-messages="errors.collect('numero')"
                      data-vv-name="numero"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4 v-if="this.financialManagers.cepLocalizado">
                    <v-text-field
                      v-model="estado"
                      label="Estado"
                      box
                      :disabled="editaEstado"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4 v-else>
                    <v-select  
                      :disabled="editaEstado"
                      v-model="estadoId"
                      label="Estado"
                      :items="estadosSelect"
                      v-validate="'required'"
                      :error-messages="errors.collect('estados')"
                      data-vv-name="estados"
                      item-text="text"
                      item-value="value"
                      box
                      @change="carregaCidades()"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 lg4 v-if="this.financialManagers.cepLocalizado">      
                    <v-text-field
                      v-model="cidade"
                      label="Cidade"
                      box
                      :disabled="editaCidade"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4 v-else>
                    <v-select  
                      :disabled="editaCidade"
                      v-model="cidadeId"
                      label="Cidade"
                      :items="cidades"
                      v-validate="'required'"
                      :error-messages="errors.collect('estados')"
                      data-vv-name="estados"
                      item-text="text"
                      item-value="value"
                      box
                      @change="carregaBairros()"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 lg4 v-if="this.financialManagers.cepLocalizado">
                    <v-text-field
                      v-model="bairro"
                      label="Bairro"
                      box
                      :disabled="editaBairro"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4 v-else>
                    <v-select  
                      :disabled="editaBairro"
                      v-model="bairroId"
                      label="Bairro"
                      :items="bairros"
                      v-validate="'required'"
                      :error-messages="errors.collect('bairros')"
                      data-vv-name="bairros"
                      item-text="text"
                      item-value="value"
                      box
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 lg12>
                    <v-text-field
                      v-model="financialManagers.addressComplement"
                      label="Complemento"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card>
              <v-btn style="border-radius: 8px;" large dark color="#8395A7" @click="avancaPasso5()">Continuar</v-btn>
              <v-btn style="border-radius: 8px; width: 250px;" large dark color="blue-grey darken-1" @click="salvarContinuar()">Salvar e continuar depois</v-btn>
            </v-container>
          </v-stepper-content>
          <!-- FIM DO PASSO 4 -->

          <!-- PASSO 5 -->
          <v-stepper-content step="5">  
            <v-alert :value="alertTitular" type="info" color="primary">Informe um Titular para o plano!</v-alert>
            <v-container fluid grid-list-md>
              <v-data-iterator
                v-if="!alertTitular"
                :items="dependentes"
                :rows-per-page-items="rowsPerPageItems"
                rows-per-page-text="Linhas por página" 
                :pagination.sync="pagination"
                content-tag="v-layout"
                row
                wrap
                hide-actions
              >
                <template v-slot:header>
                  <v-toolbar style="border-radius: 10px;" class="mb-2" color="#8395A7" dark flat>
                    <v-toolbar-title>Titular/Dependentes</v-toolbar-title>
                  </v-toolbar>
                </template>
                <template v-slot:item="props">
                  <v-flex xs12 sm6 md4 lg4>
                    <v-card style="border-radius: 10px;">
                      <v-card-title style="justify-content: center;" class="subheading font-weight-bold">{{ props.item.firstName.toUpperCase() }}</v-card-title>
                      <v-divider></v-divider>
                      <v-list dense>
                        <v-list-tile>
                          <v-list-tile-content class="centralizar" >{{ props.item.namePlan}}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content class="centralizar" >{{ props.item.parentage == '' ? 'TITULAR' : props.item.parentage}}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content v-if="!planosDiferentes" class="centralizar" >R$ {{ valorPlano }}</v-list-tile-content>
                          <v-list-tile-content v-else class="centralizar" >R$ {{ props.item.valuePlan }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>       
                          <v-btn style="border-radius: 8px;" dark color="blue-grey darken-1" @click="editItem(props.item)">Editar</v-btn>
                          <v-btn v-if="!props.item.isHolder" style="border-radius: 8px;" dark color="error" @click="openDialogDelete(props.item)">Excluir</v-btn>
                        </v-list-tile>
                      </v-list>
                    </v-card>
                  </v-flex>
                </template>      
              </v-data-iterator>
            </v-container>
            <!-- DIALOG DA LISTA DE BENEFICIARIOS -->
            <v-flex xs12 sm12 lg12>
              <v-container grid-list-md v-if="!alertTitular">
                <v-layout row wrap justify-center>
                  <v-btn @click="openDialogDependete()" dark style="border-radius: 8px;" large color="#cc9966" :disabled="inserirDepBloq">
                    Incluir Dependente
                  </v-btn>
                </v-layout>
              </v-container>         
            </v-flex>
            <v-dialog v-model="dialog" max-width="850px" persistent>                      
              <v-card>                                                        
                <v-card-title v-if="!dependents.isHolder">
                  <span class="headline">{{ formTitle }}</span>                               
                </v-card-title>
                <v-card-title v-else>
                  <span class="headline">{{ formTitleTitular }}</span>                               
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm12 lg12 v-if="dependents.isHolder">
                        <v-select  
                          disabled
                          v-model="selecaoPlano"
                          label="Plano Selecionado*"
                          :items="planos"
                          v-validate="'required'"
                          :error-messages="errors.collect('selecaoplan')"
                          data-vv-name="selecaoplan"
                          item-text="descricao"
                          item-value="id"
                          box
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg12 v-else>
                        <v-select
                          v-model="selecaoPlano"
                          label="Plano Selecionado*"
                          :items="planos"
                          v-validate="'required'"
                          :error-messages="errors.collect('selecaoplan')"
                          data-vv-name="selecaoplan"
                          item-text="descricao"
                          item-value="id"
                          box
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg4 v-if="!dependents.isHolder">      
                        <v-select                
                          v-model="dependents.parentage"
                          label="Parentesco*"
                          v-validate="'required'"
                          :error-messages="errors.collect('parentage')"
                          data-vv-name="parentage"
                          :items="parentesco"
                          item-text="text"
                          item-value="value"
                          box
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg8 v-if="!dependents.isHolder">      
                        <v-text-field
                          v-model="dependents.firstName"
                          label="Nome Completo*"
                          box
                          v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                          :error-messages="errors.collect('firstNameDep')"
                          data-vv-name="firstNameDep"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 lg12 v-else>
                        <v-text-field
                          v-model="dependents.firstName"
                          label="Nome Completo*"
                          box
                          v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                          :error-messages="errors.collect('firstNameDep')"
                          data-vv-name="firstNameDep"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 lg4>      
                        <v-text-field
                          v-model="dependents.cpf"
                          label="CPF*"
                          v-validate="'required|cpf'"
                          :error-messages="errors.collect('cpfDep')"
                          return-masked-value mask="###.###.###-##"
                          data-vv-name="cpfDep"
                          box
                        ></v-text-field>
                      </v-flex>              
                      <v-flex xs12 sm12 lg4>      
                        <v-text-field
                          v-model="dataNascDependent"
                          label="Data de Nascimento*"
                          v-validate="'required|date_format:dd/MM/yyyy'"
                          :error-messages="errors.collect('dateOfBirthDep')"
                          return-masked-value mask="##/##/####"
                          data-vv-name="dateOfBirthDep"
                          box
                        ></v-text-field>
                      </v-flex>                            
                      <v-flex xs12 sm12 lg4>      
                        <v-text-field
                          v-model="dependents.susNumber"
                          label="CNS (Cartão do SUS)"
                          v-validate="'cns'"
                          :error-messages="errors.collect('cns')"
                          data-vv-name="cns"
                          box
                        ></v-text-field>
                      </v-flex> 
                      <v-flex xs12 sm12 lg3>      
                        <v-select
                          v-model="dependents.maritalStatus"
                          label="Estado Civil*"
                          v-validate="'required'"
                          :error-messages="errors.collect('maritalStatusDep')"
                          data-vv-name="maritalStatusDep"
                          :items="estadoscivil"
                          item-text="text"
                          item-value="value"
                          box
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg3>      
                        <v-select
                          v-model="dependents.gender"
                          label="Sexo*"
                          v-validate="'required'"
                          :error-messages="errors.collect('genderDep')"
                          data-vv-name="genderDep"
                          :items="generos"
                          item-text="text"
                          item-value="value"
                          box
                        ></v-select>
                      </v-flex>               
                      <v-flex xs12 sm12 lg6>      
                        <v-text-field
                          v-model="dependents.motherName"
                          label="Nome da Mãe*"
                          v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                          :error-messages="errors.collect('motherNameDep')"
                          data-vv-name="motherNameDep"
                          box
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>          
                  <v-btn dark color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="salvarDependente">Salvar</v-btn>
                  <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- FIM DIALOG DEPENDENTES --> 

            <!-- DIALOG DELETA DEPENDENTE -->
            <v-dialog v-model="dialogDelete" max-width="600px" persistent>
              <v-card>
                <v-card-title>
                  <span class="headline">Confirmação de Exclusão</span>
                </v-card-title>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-card-text>Dependente: {{dependents.firstName}}</v-card-text>
                    <v-card-text>Parentesco: {{dependents.parentage}}</v-card-text>
                  </v-layout>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click.native="deleteDependente()">Excluir</v-btn>
                  <v-btn color="red darken-1" style="border-radius: 8px; width: 130px;" dark @click.native="close">Cancelar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- FIM DIALOG DELETA DEPENDENTE -->
        
            <br>
            <v-flex xs12 sm12 lg12 v-if="alertTitular">
              <v-container grid-list-md>
                <v-layout row wrap justify-center>
                  <v-btn style="border-radius: 8px;" large dark color="#cc9966" @click="openDialog()">Incluir Titular</v-btn>
                </v-layout>
              </v-container>
              <br>
              <br>
            </v-flex>
            <div class="separator dark"></div>
            <v-container grid-list-md>
              <v-layout row wrap justify-center>
                <v-flex xs12 sm12 lg12>
                  <div class="total-table">
                    <p class="form-titulo" >Valores</p>
                    <div class="row-table-wrapper">                  
                      <div class="col" style="width: 36%;">
                        <div class="row-table titular">
                          <p>Beneficiário Titular</p>
                          <span class="total">R$ {{valorTitular.replace('.',',')}}</span>
                        </div>
                        <div class="row-table dependentes-row">
                          <p>Dependente(s)</p>
                          <span class="total">R$ {{valorDependentes}}</span>
                        </div>
                      </div>
                      <div class="col" style="margin-right: 14%;"  v-if="planoSelecionado.taxaImplantacao != '0,00'">
                        <div class="row-table total-row">
                          <p>Total a pagar + Taxa de Implantação</p>
                          <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
                        </div>
                      </div>
                      <div class="col" style="margin-right: 14%;" v-else>
                        <div class="row-table total-row">
                          <p>Total a pagar</p>
                          <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
                        </div>                        
                      </div>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 lg12  v-if="planoSelecionado.taxaImplantacao != '0,00'">
                  <p style="font-weight:bolder">*Taxa de implantação única: R$ 4,00 por pessoa (Apenas na primeira mensalidade)</p> 
                </v-flex>
              </v-layout>
            </v-container>
            <!-- FIM DO DIALOG DA LISTA DE BENEFICIARIOS -->
            <v-card-actions>
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex md12 xs12 sm12 lg2>
                    <v-btn style="border-radius: 8px;" large dark color="#8395A7" @click="avancaPasso6()">Continuar</v-btn>
                  </v-flex>
                  <v-flex md12 xs12 sm12 lg2>
                    <v-btn @click="salvarContinuar()" style="border-radius: 8px; width: 250px;" large dark color="blue-grey darken-1">Salvar e continuar depois</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>
          </v-stepper-content>
          <!-- FIM DO PASSO 5 -->

          <!-- PASSO 6 -->
          <v-stepper-content step="6">
            <v-card class="mb-5" min-height="200px" flat>
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 sm12 lg12 v-if="exibeVendedor">      
                    <p class="form-titulo" >Corretor</p>
                    <v-flex xs12 sm12 lg12>            
                      <v-radio-group v-model="temVendedor" row :disabled="linkVendedor">
                        <strong style="font-weight: bold;">Você foi auxiliado por algum corretor? &nbsp;&nbsp;</strong>
                        <v-radio color="#446fb5" label="Sim" :value="true"></v-radio>
                        <v-radio color="#446fb5" label="Não" :value="false"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="!linkVendedor">
                      <v-text-field                
                        v-if="temVendedor ? true : cpfVendedor = ''"
                        v-model="cpfVendedor"
                        label="CPF"                
                        box
                        return-masked-value mask="###.###.###-##"
                        @blur="consultaVendedor()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>      
                      <v-text-field
                        v-if="temVendedor ? temVendedor == true : nomeVendedor = ''"
                        v-model="nomeVendedor"
                        label="Corretor"
                        box
                        disabled
                      ></v-text-field>
                    </v-flex>
                    <hr>
                    <br>
                  </v-flex>
                  <v-flex xs12 sm12 lg12>      
                    <p class="form-titulo">Contrato</p>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg8 v-if="planoSelecionado.urlContrato != '' && planoSelecionado.urlContrato != undefined">
                    <iframe v-if="this.$vuetify.breakpoint.lg" :src="`${pdfSelecionado}`" width="680" height="400" style="border: none;"></iframe>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg4>
                    <div v-if="this.$vuetify.breakpoint.lg">
                      <v-list-tile
                        v-if="planoSelecionado.urlContrato != '' && planoSelecionado.urlContrato != undefined"
                        @click="pdfSelecionado = planoSelecionado.urlContrato" avatar
                      >
                        <v-list-tile-action>
                          <img src="../Content/images/pdf.png" width="30px">
                        </v-list-tile-action>
                        <v-list-tile-title>Contrato</v-list-tile-title>
                      </v-list-tile>
                    </div>
                    <div v-else>
                      <v-list-tile
                        v-if="planoSelecionado.urlMinutaContrato != '' && planoSelecionado.urlMinutaContrato != undefined"
                        @click="pdfSelecionado = planoSelecionado.urlMinutaContrato" :href="planoSelecionado.urlMinutaContrato" target='_blank' avatar
                      >
                        <v-list-tile-action>
                          <img src="../Content/images/pdf.png" width="30px">
                        </v-list-tile-action>
                        <v-list-tile-title>Minuta do Contrato</v-list-tile-title>
                      </v-list-tile>
                    </div>

                    <div v-if="this.$vuetify.breakpoint.lg">
                      <v-list-tile
                        v-if="planoSelecionado.urlMinutaAditivo != '' && planoSelecionado.urlMinutaAditivo != undefined"
                        @click="pdfSelecionado = planoSelecionado.urlMinutaAditivo" avatar
                      >
                        <v-list-tile-action>
                          <img src="../Content/images/pdf.png" width="30px">
                        </v-list-tile-action>
                        <v-list-tile-title>Minuta do Aditivo</v-list-tile-title>
                      </v-list-tile>
                    </div>
                    <div v-else>
                      <v-list-tile
                        v-if="planoSelecionado.urlMinutaAditivo != '' && planoSelecionado.urlMinutaAditivo != undefined"
                        @click="pdfSelecionado = planoSelecionado.urlMinutaAditivo" :href="planoSelecionado.urlMinutaAditivo" target='_blank' avatar
                      >
                        <v-list-tile-action>
                          <img src="../Content/images/pdf.png" width="30px">
                        </v-list-tile-action>
                        <v-list-tile-title>Minuta do Aditivo</v-list-tile-title>
                      </v-list-tile>
                    </div>

                    <div v-if="this.$vuetify.breakpoint.lg">
                      <v-list-tile
                        v-if="planoSelecionado.urlCobertura != '' && planoSelecionado.urlCobertura != undefined"
                        @click="pdfSelecionado = planoSelecionado.urlCobertura" avatar
                      >
                        <v-list-tile-action>
                          <img src="../Content/images/pdf.png" width="30px">
                        </v-list-tile-action>
                        <v-list-tile-title>Cobertura do Plano</v-list-tile-title>
                      </v-list-tile>
                    </div>
                    <div v-else>
                      <v-list-tile
                        v-if="planoSelecionado.urlCobertura != '' && planoSelecionado.urlCobertura != undefined"
                        @click="pdfSelecionado = planoSelecionado.urlCobertura" :href="planoSelecionado.urlCobertura" target='_blank' avatar
                      >
                        <v-list-tile-action>
                          <img src="../Content/images/pdf.png" width="30px">
                        </v-list-tile-action>
                        <v-list-tile-title>Cobertura do Plano</v-list-tile-title>
                      </v-list-tile>
                    </div>

                    <div v-if="this.$vuetify.breakpoint.lg">
                      <v-list-tile
                        v-if="planoSelecionado.urlManual != '' && planoSelecionado.urlManual != undefined"
                        @click="pdfSelecionado = planoSelecionado.urlManual" avatar
                      >
                        <v-list-tile-action>
                          <img src="../Content/images/pdf.png" width="30px">
                        </v-list-tile-action>
                        <v-list-tile-title>Manual de Orientação</v-list-tile-title>
                      </v-list-tile>
                    </div>
                    <div v-else>
                      <v-list-tile
                        v-if="planoSelecionado.urlManual != '' && planoSelecionado.urlManual != undefined"
                        @click="pdfSelecionado = planoSelecionado.urlManual" :href="planoSelecionado.urlManual" target='_blank' avatar
                      >
                        <v-list-tile-action>
                          <img src="../Content/images/pdf.png" width="30px">
                        </v-list-tile-action>
                        <v-list-tile-title>Manual de Orientação</v-list-tile-title>
                      </v-list-tile>
                    </div>

                    <div v-if="this.$vuetify.breakpoint.lg">
                      <v-list-tile
                        v-if="planoSelecionado.urlGuia != '' && planoSelecionado.urlGuia != undefined"
                        @click="pdfSelecionado = planoSelecionado.urlGuia" avatar
                      >
                        <v-list-tile-action>
                          <img src="../Content/images/pdf.png" width="30px">
                        </v-list-tile-action>
                        <v-list-tile-title>Guia de Leitura Contratual</v-list-tile-title>
                      </v-list-tile>
                    </div>
                    <div v-else>
                      <v-list-tile
                        v-if="planoSelecionado.urlGuia != '' && planoSelecionado.urlGuia != undefined"
                        @click="pdfSelecionado = planoSelecionado.urlGuia" :href="planoSelecionado.urlGuia" target='_blank' avatar
                      >
                        <v-list-tile-action>
                          <img src="../Content/images/pdf.png" width="30px">
                        </v-list-tile-action>
                        <v-list-tile-title>Guia de Leitura Contratual</v-list-tile-title>
                      </v-list-tile>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm3 md12 lg12>
                    <v-checkbox v-model="contrataccept" color="#8395A7">
                      <span slot="label">Li e concordo com os termos do contrato</span>
                    </v-checkbox>
                  </v-flex>
                  <hr>
                  <br>
                  <v-flex xs12 sm12 lg12>      
                    <p class="form-titulo" >Resumo da proposta</p>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>
                    <div class="resumo">
                      <p style="margin-bottom: 0px;">Beneficiário Titular</p>
                      <span class="subtotal">R$ {{valorTitular.replace('.',',')}}</span>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>
                    <div class="resumo">
                      <p style="margin-bottom: 0px;">Dependente(s)</p>
                      <span class="subtotal">R$ {{valorDependentes}}</span>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <div class="resumo" v-if="planoSelecionado.taxaImplantacao != '0,00'">
                      <p style="margin-bottom: 0px;">Total a pagar + Taxa de Implantação</p>
                      <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>                  
                    </div>
                    <div class="resumo" v-else>
                      <p style="margin-bottom: 0px;">Total a pagar</p>
                      <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
                    </div>   
                    <br>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="planoSelecionado.taxaImplantacao != '0,00'">
                    <p style="font-weight:bolder">*Taxa de implantação única: R$ 4,00 por pessoa (Apenas na primeira mensalidade)</p> 
                  </v-flex>
                  <br>
                  <v-layout row wrap v-if="!financialManagers.reteveAdesao">
                    <!-- <v-flex xs12 sm12 lg12>
                      <p class="form-titulo">Pagamento</p>              
                      <v-radio-group v-model="tipoPagamento" v-if="tipoPagamento != 'BOLETO'" row >
                        <strong style="font-weight: bold;">Escolha a forma de pagamento:</strong>
                        <v-radio color="#8395A7" label="CRÉDITO" value='CARTAO'></v-radio>
                        <v-radio color="#8395A7" label="DÉBITO BANCO DO BRASIL" value='DEBITO'></v-radio>
                      </v-radio-group>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg3 v-if="informacaoOperadora('usaCupomDesconto')">
                      <v-text-field
                        v-model="financialManagers.cupomDesconto"
                        label="Cupom de desconto"
                        box
                        dense
                        :disabled="cupomAplicado"
                        color="#8395A7" 
                      ></v-text-field>
                    </v-flex>
                    <v-flex md12 xs12 sm12 lg3 v-if="informacaoOperadora('usaCupomDesconto')">
                      <v-btn style="border-radius: 8px;" large dark :disabled="cupomAplicado" color="#1DAFFC" @click="aplicaCupom()">Aplicar</v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-if="informacaoOperadora('usaCupomDesconto')">
                      <v-chip close v-model="cupomAplicado" color="teal" text-color="white">
                        <v-avatar>
                          <v-icon>check_circle</v-icon>
                        </v-avatar>
                        Cupom aplicado
                      </v-chip>
                    </v-flex>

                    <v-flex xs12 sm12 lg12 v-if="tipoPagamento == 'CARTAO'">
                      <br>
                      <v-layout row wrap justify-center style="background-color:#dbe3e8;">
                        <v-flex xs12 sm12 lg4 v-if="informacaoOperadora('usaPagamentoMensalCartao')">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Mensal Recorrente</h6>
                                <br>
                                <p class="price"><span>R$</span> {{valorTotalProposta.replace('.',',')}}<br></p>
                                <br>
                                <br v-if="this.primeiraParcela != '0,00'">
                                <h6 class="desconto" style="text-align: center;">Mensal automático</h6>
                                <a v-if="gatewayPagamento == 'EG'" @click="pagarCartaoEG('mensal')" class="button">Fazer Pagamento</a>
                                <a v-else @click="pagamentoCartao('mensal')" class="button">Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>  
                        <v-flex xs12 sm12 lg4 v-if="(cupomAdesao && informacaoOperadora('usaPagamentoAnualParceladoCartao')) || (!cupomAdesao && informacaoOperadora('usaPagamentoAnualParceladoCartao'))">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; color: #7fa761">Anual Parcelado</h6>
                                <br>
                                <p class="price" style="color: #7fa761"><span>R$</span> {{valorAnualProposta.toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;" v-if="this.primeiraParcela == '0,00'">Em 12x de {{valorTotalProposta.replace('.',',')}}</h6>
                                <h6 class="desconto" style="text-align: center;" v-else>Adesão de R$ {{this.primeiraParcela.toFixed(2).replace('.',',')}} <br> e 11x de R$ {{((this.valorAnualProposta - this.primeiraParcela)/11).toFixed(2).replace('.',',')}}</h6>
                                <a v-if="gatewayPagamento == 'EG'" @click="pagarCartaoEG('anualParcelado')" class="button">Fazer Pagamento</a>
                                <a v-else @click="pagamentoCartao('anualParcelado')" class="button">Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                        <v-flex xs12 sm12 lg4 v-if="(cupomAdesao && informacaoOperadora('usaPagamentoAnualCartao')) || (!cupomAdesao && informacaoOperadora('usaPagamentoAnualCartao'))">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; color: #7fa761">Anual à Vista</h6>
                                <br>
                                <p class="price" style="color: #7fa761"><span>R$</span> {{valorAnualProposta.toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Pagamento anual</h6>
                                <a v-if="gatewayPagamento == 'EG'" @click="pagarCartaoEG('anual')" class="button">Fazer Pagamento</a>
                                <a v-else @click="pagamentoCartao('anual')" class="button">Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <!-- <v-flex xs12 sm12 lg12 v-if="tipoPagamento == 'DEBITO'">           
                      <br>
                      <v-layout row wrap justify-center style="background-color:#dbe3e8;">
                        <v-flex xs12 sm12 lg4 v-if="informacaoOperadora('usaPagamentoMensal')">                
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Plano Mensal</h6>
                                <br>
                                <p class="price"><span>R$</span> {{valorTotalProposta.replace('.',',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Débito automático</h6>
                                <a @click="pagamentoCartao('mensal')" class="button">Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                        <v-flex xs12 sm12 lg4 v-if="informacaoOperadora('usaPagamentoAnualParceladoCartao')">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; color: #7fa761">Plano Anual</h6>
                                <br>
                                <p class="price" style="color: #7fa761"><span>R$</span> {{parseFloat(valorTotalProposta*12).toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Desconto especial de 10%</h6>
                                <a @click="pagamentoCartao('anualParcelado')" class="button" >Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex> -->
                      
                    <v-flex xs12 sm12 lg12 v-if="tipoPagamento == 'BOLETO'">
                      <br>
                      <v-layout row wrap justify-center style="background-color:#dbe3e8;">
                        <v-flex xs12 sm12 lg4 v-if="informacaoOperadora('usaPagamentoMensalBoleto')">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Plano Mensal</h6>
                                <br>
                                <p class="price"><span>R$</span> {{valorTotalProposta.replace('.',',')}}<br></p>
                                <br>
                                <br v-if="this.primeiraParcela != '0,00'">
                                <h6 class="desconto" style="text-align: center;">Primeira parcela</h6>
                                <a v-if="gatewayPagamento == 'EG'" @click="pagamentoBoletoEG('mensal')" class="button">Gerar Boleto</a>
                                <a v-else @click="pagamentoBoleto('mensal')" class="button">Gerar Boleto</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>

                        <v-flex xs12 sm12 lg4 v-if="(cupomAdesao && informacaoOperadora('usaPagamentoAnualBoleto')) || (!cupomAdesao && informacaoOperadora('usaPagamentoAnualBoleto'))">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; color: #7fa761">Plano Anual</h6>
                                <br>
                                  <p class="price" style="color: #7fa761" v-if="primeiraParcela == '0,00'"><span>R$</span> {{(parseFloat(valorTotalProposta) * 12).toFixed(2).replace('.', ',')}}</p>
                                  <p class="price" style="color: #7fa761" v-else><span>R$</span> {{(parseFloat(valorTotalProposta) * 22 + parseFloat(primeiraParcela)).toFixed(2).replace('.', ',')}}</p>                            
                                  <br>                             
                                  <h6 class="desconto" style="text-align: center;" v-if="this.primeiraParcela == '0,00'">Pagamento Anual</h6>
                                  <h6 class="desconto" style="text-align: center;" v-else>Adesão de R$ {{this.primeiraParcela.toFixed(2).replace('.',',')}} <br> e 11x de R$ {{((parseFloat(this.valorAnualProposta) - parseFloat(this.primeiraParcela))/11).toFixed(2).replace('.',',')}}</h6>
                                  <!-- <h6 class="desconto" style="text-align: center;">Desconto especial de 10%</h6> -->
                                <a v-if="gatewayPagamento == 'EG'" @click="pagamentoBoletoEG('anual')" class="button" >Gerar Boleto</a>
                                <a v-else @click="pagamentoBoleto('anual')" class="button" >Gerar Boleto</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>             
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap v-else>
                    <hr>
                    <br>
                    <v-flex xs12 sm12 lg12>
                      <p class="form-titulo" >Pagamento</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg3 v-if="informacaoOperadora('usaCupomDesconto')">
                      <v-text-field
                        v-model="financialManagers.cupomDesconto"
                        label="Cupom de desconto"
                        box
                        dense
                        :disabled="cupomAplicado"
                        color="#8395A7" 
                      ></v-text-field>
                    </v-flex>
                    <v-flex md12 xs12 sm12 lg3 v-if="informacaoOperadora('usaCupomDesconto')">
                      <v-btn style="border-radius: 8px;" large dark :disabled="cupomAplicado" color="#1DAFFC" @click="aplicaCupom()">Aplicar</v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-if="informacaoOperadora('usaCupomDesconto')">
                      <v-chip close v-model="cupomAplicado" color="teal" text-color="white">
                        <v-avatar>
                          <v-icon>check_circle</v-icon>
                        </v-avatar>
                        Cupom aplicado
                      </v-chip>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-if="tipoPagamento == 'CARTAO'">
                        <br>
                        <v-layout row wrap justify-center style="background-color:#dbe3e8;">
                        <!-- <v-flex xs12 sm12 lg4>                
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Mensal Recorrente</h6>
                                <br>
                                <p class="price"><span>R$</span> {{valorTotalProposta.replace('.',',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Mensal automático</h6>
                                <a @click="pagamentoCartao('mensal')" class="button">Enviar dados</a>
                              </div>
                            </div>
                          </div>
                        </v-flex> -->
                        <v-flex xs12 sm12 lg4 v-if="informacaoOperadora('usaPagamentoAnualCartao')">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; color: #7fa761">Anual à Vista</h6>
                                <br>
                                <p v-if="this.dependentes.length == 1" class="price" style="color: #7fa761"><span>R$</span> {{parseFloat((valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*11).toFixed(2).replace('.', ',')}}<br></p>
                                <p v-if="this.dependentes.length > 1" class="price" style="color: #7fa761"><span>R$</span> {{parseFloat((valorTotalProposta - (this.planoSelecionado.descontoAnualFamilia.replace(',', '.') * dependentes.length))*11).toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Desconto especial</h6>
                                <a v-if="gatewayPagamento == 'EG'" @click="pagarCartaoEG('anual')" class="button" >Fazer Pagamento</a>
                                <a v-else @click="pagamentoCartao('anual')" class="button" >Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                        <v-flex xs12 sm12 lg4 v-if="informacaoOperadora('usaPagamentoAnualParceladoCartao')">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; color: #7fa761">Anual Parcelado</h6>
                                <br>
                                <p v-if="this.dependentes.length == 1" class="price" style="color: #7fa761"><span>R$</span> {{parseFloat((valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*11).toFixed(2).replace('.', ',')}}<br></p>
                                <p v-if="this.dependentes.length > 1" class="price" style="color: #7fa761"><span>R$</span> {{parseFloat((valorTotalProposta - (this.planoSelecionado.descontoAnualFamilia.replace(',', '.') * dependentes.length))*11).toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 v-if="this.dependentes.length == 1" class="desconto" style="text-align: center;">Em 11x de R$ {{parseFloat((valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))).toFixed(2).replace('.', ',')}}</h6>
                                <h6 v-if="this.dependentes.length > 1" class="desconto" style="text-align: center;">Em 11x de R$ {{parseFloat((valorTotalProposta - (this.planoSelecionado.descontoAnualFamilia.replace(',', '.') * dependentes.length))).toFixed(2).replace('.', ',')}}</h6>
                                <a v-if="gatewayPagamento == 'EG'" @click="pagarCartaoEG('anualParcelado')" class="button" >Fazer Pagamento</a>
                                <a v-else @click="pagamentoCartao('anualParcelado')" class="button" >Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  
                    <v-flex xs12 sm12 lg12 v-if="tipoPagamento == 'BOLETO'">
                      <br>
                      <v-layout row wrap justify-center style="background-color:#dbe3e8;">
                        <v-flex xs12 sm12 lg4 v-if="informacaoOperadora('usaPagamentoMensalBoleto')">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Plano Mensal</h6>
                                <br>
                                <p class="price"><span>R$</span> {{valorTotalProposta.replace('.',',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Recorrente</h6>
                                <a @click="enviarProposta()" class="button">Enviar Proposta</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>  

                        <v-flex xs12 sm12 lg4 v-if="informacaoOperadora('usaPagamentoAnualBoleto')">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; color: #7fa761">Plano Anual</h6>
                                <br>
                                <p v-if="this.dependentes.length == 1" class="price" style="color: #7fa761"><span>R$</span> {{parseFloat((valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*11).toFixed(2).replace('.', ',')}}<br></p>
                                <p v-if="this.dependentes.length > 1" class="price" style="color: #7fa761"><span>R$</span> {{parseFloat((valorTotalProposta - (this.planoSelecionado.descontoAnualFamilia.replace(',', '.') * dependentes.length))*11).toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Desconto especial</h6>
                                <a v-if="gatewayPagamento == 'EG'" @click="pagamentoBoletoEG('anual')" class="button" >Gerar Boleto</a>
                                <a v-else @click="pagamentoBoleto('anual')" class="button" >Gerar Boleto</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card>

            <!-- DIALOG CARTÃO DE CRÉDITO -->
            <v-dialog v-model="dialogCartao" max-width="900px" persistent>
              <v-card>
                <v-card-title>
                  <span v-if="tipoPagamento == 'CARTAO'" class="headline">Pagamento com Cartão de Crédito</span> 
                  <!-- <span v-else class="headline">Pagamento com Débito</span> -->
                </v-card-title>
                <v-container grid-list-md>
                  <!-- <v-flex xs12 sm12 lg12>
                    <p style="color:#F57C00" class="subtotal">O cartão deve pertencer ao responsável financeiro*</p>
                    <br>
                  </v-flex> -->
                  <v-flex xs12 sm12 lg12>
                    <p class="form-titulo" v-if="tipoPagamento == 'CARTAO'">Dados do Cartão de Crédito</p>
                  </v-flex>             
                  <v-layout row wrap>
                    <v-flex d-flex xs12 sm6 md6>
                      <vue-card v-if="tipoPagamento == 'CARTAO'" :number='modelCartao.cartao.numero' :cvv='modelCartao.cartao.codigoSeguranca' :mes='modelCartao.cartao.expiracaoMes' :nome='modelCartao.cartao.nome' :ano='validadeCartaoAno' animate :side='side'/>
                    </v-flex>
                    <v-flex d-flex xs12 sm6 md6 v-if="tipoPagamento == 'CARTAO'">
                      <v-layout row wrap>
                        <v-flex d-flex xs12 sm6 md12 >
                          <v-text-field              
                            v-model="modelCartao.cartao.nome"
                            label="Nome (Como está impresso no Cartão)"
                            v-validate="'required'"
                            :error-messages="errors.collect('nomeCartao')"
                            data-vv-name="nomeCartao"
                            box
                            @keydown="side=1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex d-flex xs12 sm6 md6>
                          <v-text-field
                            v-model="modelCartao.cartao.numero"
                            label="Número do Cartão"
                            v-validate="'required|credit_card'"
                            :error-messages="errors.collect('numCartao')"
                            data-vv-name="numCartao"
                            mask="#### #### #### ####"
                            box
                            @keydown="side=1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex d-flex xs12 sm6 md6>
                          <v-select
                            v-model="modelCartao.cartao.bandeira"
                            label="Bandeira"
                            v-validate="'required'"
                            :error-messages="errors.collect('bandeiraCartao')"
                            data-vv-name="bandeiraCartao"
                            :items="bandeiras"
                            item-text="text"
                            item-value="value"
                            box
                            @keydown="side=1"
                          ></v-select>
                        </v-flex>
                        <v-flex d-flex xs12 sm6 md4>          
                          <v-text-field
                            v-model="modelCartao.cartao.expiracaoMes"
                            label="Validade Mês"
                            v-validate="'required'"
                            :error-messages="errors.collect('expiraCartaoMes')"
                            data-vv-name="expiraCartaoMes"
                            return-masked-value mask="##"
                            box
                            @keydown="side=1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex d-flex xs12 sm6 md4> 
                          <v-select
                            v-model="validadeCartaoAno"
                            label="Validade Ano*"
                            v-validate="'required'"
                            :error-messages="errors.collect('expiraCartaoAno')"
                            data-vv-name="expiraCartaoAno"
                            :items="anoValidade"
                            @keydown="side=1"
                            box
                          ></v-select>
                        </v-flex>                    
                        <v-flex d-flex xs12 sm6 md4 v-if="tipoPagamento == 'CARTAO'"> 
                          <v-text-field
                            v-model="modelCartao.cartao.codigoSeguranca"
                            label="CVV"
                            v-validate="`required`"
                            :error-messages="errors.collect('codCartao')"
                            data-vv-name="codCartao"
                            mask="####"
                            box
                            @keydown="side=2"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex> 
                    <v-flex xs12 sm12 lg12 v-else>
                      <p class="form-titulo" >Dados do Débito em Conta</p>            
                      <v-layout row wrap>
                        <v-flex xs12 sm12 lg3>        
                          <v-select
                            v-model="financialManagers.bancoDeb"
                            label="Banco*"
                            v-validate="'required'"
                            :error-messages="errors.collect('bancoDeb')"
                            data-vv-name="bancoDeb"
                            :items="bancos"
                            item-text="text"
                            item-value="value"
                            box
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm12 lg3> 
                          <v-text-field
                            v-model="financialManagers.agenciaDeb"
                            label="Agência (com dígito)*"
                            mask="####-#"
                            v-validate="'required'"
                            :error-messages="errors.collect('agenciaDeb')"
                            data-vv-name="agenciaDeb"
                            box
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 lg3> 
                          <v-text-field
                            v-model="financialManagers.contaDeb"
                            label="Conta (com dígito)*"
                            type="tel"
                            v-validate="'required'"
                            :error-messages="errors.collect('contaDeb')"
                            data-vv-name="contaDeb"
                            box
                          ></v-text-field>
                        </v-flex>
                        <hr>
                        <br>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="!this.pegaDadosCartao" color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click.native="pagarCartao()">Confirmar</v-btn>
                    <v-btn v-else color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click.native="enviarProposta()">Confirmar</v-btn>
                    <!-- <v-btn v-if="tipoPagamento == 'DEBITO'" color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click.native="pagarDebito()">Confirmar</v-btn> -->
                    <v-btn color="red darken-1" style="border-radius: 8px; width: 130px;" dark @click.native="close()">Cancelar</v-btn>
                  </v-card-actions>                   
                </v-container>          
              </v-card>
            </v-dialog>
            <!-- FIM DIALOG CARTÃO DE CRÉDITO -->

            <v-dialog v-model="dialogoBoleto" persistent max-width="500px">
              <v-card>
                <v-card-text style="padding-bottom: 0px">
                  <p style="color: #229A00; text-align: center; font-size: 20px; font-weight: bold">{{ responseBoleto.Valor }}</p>
                  <v-container grid-list-md style="padding: 10px">
                    <v-layout row wrap>
                      <v-flex>
                        <p style="font-size: 14px; font-weight: bold">Você tem até o dia {{ responseBoleto.Vencimento.substring(0, 5) }} para pagar</p>
                        <p style="font-size: 12px; margin-top: 5px; line-height: 14px; text-align: justify">Para pagar pelo Internet Banking, copie a linha digitável. Para pagar em qualquer banco, caixa eletrônico ou lotérica, por favor, imprima o boleto.</p>
                        <p style="font-size: 12px; font-weight: bold; margin-top: 10px; line-height: 14px; text-align: justify">Se o pagamento é feito de segunda a sexta, é creditado no dia seguinte. Se você pagar no fim de semana, será creditado na terça-feira.</p>
                      </v-flex>
                      <v-flex>
                        <p style="font-size: 12px; text-align: center; margin-top: 10px; font-weight: bold">{{ responseBoleto.LinhaDigitavel }}</p>
                        <v-text-field id="linhaDigitavel" v-model="responseBoleto.LinhaDigitavel" readonly style="padding: 1px; position: absolute; left: -99999px;"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md12 lg12>
                        <v-btn block color="primary" @click="doCopy('linhaDigitavel', 'Linha digitável copiada!')">
                          <v-icon left>mdi-content-copy</v-icon>Copiar linha digitável
                        </v-btn>
                        <v-btn block color="primary" @click="imprimirBoletoEG(responseBoleto.BoletoID)" :loading="impressaoBoleto">
                          <v-icon left>print</v-icon>Imprimir boleto
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat color="red" @click="confirmaContrato()">Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Iframe -->
            <v-dialog v-model="dialogoPagamentoIframe" persistent max-width="500px" :fullscreen="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
              <v-card>
                <v-card-text style="padding: 0px">
                  <v-container grid-list-md style="padding: 10px">
                    <v-layout row wrap>
                      <v-flex>
                        <iframe :src="urlIframe" width="100%" height="500px" @load="listenMessage"></iframe>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
            
            <!-- Dialog do Boleto -->
            <v-dialog v-model="dialogoTipoPagamento" max-width="450px" max-height="300px" persistent>
              <v-card>
                <v-card-title>
                  <p class="headline">Confirmação</p>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="dialogoTipoPagamento = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <p>Escolha como deseja pagar sua adesão.</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="pagamentoBoletoEG(pagamentoTipoBoleto)">Boleto</v-btn>
                  <v-btn flat color="primary" @click="pagarPixEG(pagamentoTipoBoleto)">Pix</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogoPix" max-width="600px" width="400px" persistent scrollable>
              <v-card>
                <v-card-text>
                  <p style="color: #229A00; text-align: center; font-size: 20px; font-weight: bold">{{ responsePix.valor }}</p>
                  <v-layout row wrap style="text-align: center">
                    <v-flex xs12 sm12 md12 lg12>
                      <img :src="responsePix.qrCode" width="100%" style="max-width: 300px">
                    </v-flex>
                    <v-flex xs12 sm12 md12 lg12>
                      <v-btn dark color="#00695C" @click="doCopy('chavePix', 'Chave copiada!')" style="margin-bottom: 20px">Copiar Chave</v-btn>
                      <v-text-field id="chavePix" v-model="responsePix.link" readonly style="padding: 1px; position: absolute; left: -99999px;"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12 lg12>
                      <p class="texto">Faça a leitura do QR Code ou copie a chave e cole no aplicativo de seu banco na função "Pix Copia e Cola".</p>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="dialogoPix = false; dialogLoading = true">Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <!-- FIM DO PASSO 5 -->
      <v-dialog v-model="dialogLoading" max-width="450px" max-height="300px" persistent> 
        <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
                <span class="total">Parabéns</span>              
              </v-card-title>
              <v-container fill-height fluid pa-1 justify-center class="resumo">
                <p class="resumo" style="text-align: center;">Sua proposta nº <span style="font-weight: 700;">{{financialManagers.proposalNumber}}</span> foi encaminhada para a {{informacaoOperadora("nome")}}. Você poderá acompanhar o andamento da sua proposta na Área do Cliente.</p>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container fill-height fluid pa-1 justify-center>
                <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click="confirmaContrato()">Fechar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
    </section>
    <loading :active.sync="isLoading" :can-cancel="false" color="#8395A7" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  import FileUpload from 'vue-upload-component'
  import Snackbar from '../components/snackbar.vue'
  import axios from 'axios'
  import { baseApiUrl, modelBoleto, operadora } from '@/global'
  import CpfValidate from '../components/validators/rules/cpf'
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import vueCard from 'vue-card-express'
  export default {
    components: { Snackbar, FileUpload, Loading, vueCard },
      data() {
        return {
          cupomAdesao: false,
          pegaDadosCartao: false,
          editaBairro: true,
          editaCidade: true,
          editaEstado: true,
          editaRua: true,
          bancos: [{'value' : 'BRASIL' ,'text': 'Banco do Brasil'}],
          pagamentoTipoCartao: '',
          tipoPagamento: '',
          dadosCupom: [],
          cupomAplicado: false,
          side: 1,
          token: '',
          idCostCenter:'',
          fullPage: true,  
          isLoading: false,  
          cartaValidado: false,        
          filesRg1: [],
          filesRg2: [],
          filesCPF: [],
          filesAddress: [],
          filesOutros: [], 
          anoValidade: ['2021','2022','2023','2024','2025','2026','2027','2028','2029','2030','2031','2032','2033','2034','2035'],
          Anexos: {
            id: "ID_RESPONSAVEL_FINANCEIRO",
            imagesDocs: {
              cpf: "",
              rg: "",
              rg2: "",
              address: "",
              credtFrontal: "",
              physicalContract: "",
              adtive: "",
              others: ""
            }
          },
          rowsPerPageItems: [12, 18],
          pagination: {
            rowsPerPage: 12
          },
          exibeVendedor: true,
          linkParceriaIgrejas: false,
          linkParceriaAvanti: false,
          qtdDependentesInseridos: 0,
          pdfSelecionado: '',
          verificaTitularS4e: '',
          msgLoading: '',
          loading: false,
          financialManagUF: '',
          salesmanPlanoRiso: '5cc0a27ee2cead066040bfc9',
          brokerPlanoRiso: '5cc0a118e2cead066040bfc6',
          contrataccept: false,
          temVendedor: false,
          nomeVendedor: '',
          vendedorLink: [],
          vendedor: [],
          salesman: [],
          linkVendedor: false,
          cpfVendedor: '',
          inserirDepBloq: false,
          usarDadosFM: true,
          existeTitular: false,
          tipoTitular: false,
          radioBTtitular: true,
          alertTitular: false,
          editPassos: false,
          editedIndex: '',
          editedIndexTitular: '',
          valorDependentes: 0,
          primeiraParcela: '0,00',
          valorTotalProposta: '0,00',
          valorAnualProposta: 0.00,
          valorTitular: '0,00',
          valorFaixa: '0,00',
          valorPlano: '0,00',
          search: '',
          dialog: false,
          dialogDelete: false,
          dialogLoading: false,
          dialogCartao: false,
          dependentes: [], 
          dependentesCarregados: [],            
          AtualFinancialManagers: [],           
          e1: 0,
          bairro: '',
          cidade: '',
          estado: '',
          estados: [],
          estadosSelect: [],
          cidades: [],
          bairros: [],
          bairroId: '',
          cidadeId: '',
          estadoId: '',
          parentesco: [  
            { value: 'CÔNJUGE', text: "CÔNJUGE" },
            { value: 'FILHO', text: "FILHO(A)" },
            { value: 'PAI/MÃE', text: "PAI/MÃE" },
            { value: 'AGREGADO', text: "IRMÃO(A)" },
            { value: 'AGREGADO', text: "SOBRINHO(A)" },
            { value: 'AGREGADO', text: "NETO(A)" } 
          ],
          generos: [
            { value: 1, text: "Masculino" },
            { value: 0, text: "Feminino" }
          ],
          bandeiras: [
            { value: 'DINERS', text: "DINERS" },
            { value: 'ELO', text: "ELO" },
            { value: 'HIPERCARD', text: "HIPERCARD" },
            { value: 'MASTERCARD', text: "MASTERCARD" },
            { value: 'VISA', text: "VISA" }
          ],
          estadoscivil: [
            { value: "SOLTEIRO", text: "Solteiro(a)" },
            { value: "CASADO", text: "Casado(a)" },
            { value: "VIÚVO", text: "Viúvo(a)" },
            { value: "DIVORCIADO", text: "Divorciado(a)" }
          ],
          planoSelecionado: [],
          selecaoPlano: '',
          planos: [],
          dataNasc: '',
          dataNascDependent: '',
          dependents: {
            parentage: '',
            valuePlan: '',
            namePlan: '',
            lackOfCare: 1,
            rcaId: '',
            dateFirstPayment: '',
            isHolder: '',
            financialManagerId: '',
            firstName: '',
            lastName: '',
            dateOfBirth: '',
            gender: '',
            maritalStatus: '',
            cpf: '',
            motherName: '',
            susNumber: '',
            plansId: ''
          },
          defaultDependents: {
            parentage: '',
            valuePlan: '',
            lackOfCare: 1,
            rcaId: '',
            dateFirstPayment: '',
            isHolder: '',
            financialManagerId: '',
            firstName: '',
            lastName: '',
            dateOfBirth: '',
            gender: '',
            maritalStatus: '',
            cpf: '',
            motherName: '',
            susNumber: '',
            plansId: ''
          },
          financialManagers: {
            cupomDesconto: '',
            contratanteTitular: true,
            confirmPassword: '',
            password: '',
            rg: '',
            tokenCartao: '',
            bancoDeb: '',
            contaDeb: '',
            agenciaDeb: '',
            rgEmitter: '',
            homePhone: '',
            cellPhone: '',
            cellPhone2: '',
            email: '',
            cep: '',
            address: '',
            addressType: '',
            addressTypeName: '',
            addressNumber: '',
            addressComplement: '',
            district: '',
            city: '',
            state: '',
            proposalNumber: '',
            contractNumberS4: '',
            responsibility: '',
            cardNumber: '',
            cardValidity: '',
            cardFlag: '',
            cardCvc: '',
            cardDayExpiration: 15,
            dateSignatureContract: '',
            formOfPaymentId: '',
            formOfPayment: '',
            firstName: '',
            lastName: '',
            dateOfBirth: '',
            gender: null,
            maritalStatus: null,
            cpf: '',
            motherName: '',
            susNumber: '',
            plansId: '',
            nsu: '',
            autorizacaoCodigo: '',
            paymentId: '',
            TypeFm: 'FISICA',
            protocoloCancelamento: '',
            vendedor: '',
            CPFVendedor: '',
            matricula: '',
            stageForm: 2,
            tempPassword: false,
            originRegister: 'EXTERNO',
            existSales: '',
            salesmanId: '5cc0a27ee2cead066040bfc9',
            brokerId: '5cc0a118e2cead066040bfc6',
            qtdDependentes: '',
            situacaoBoleto: '',
            modalidadePagamento: '',
            cidadeId: '',
            cepLocalizado: true,
            reteveAdesao: false,
          },
          defaultfinancialManagers: {
            cupomDesconto: '',
            contratanteTitular: true,
            confirmPassword: '',
            password: '',
            rg: '',
            bancoDeb: '',
            contaDeb: '',
            agenciaDeb: '',
            rgEmitter: '',
            homePhone: '',
            cellPhone: '',
            cellPhone2: '',
            email: '',
            cep: '',
            address: '',
            addressType: '',
            addressTypeName: '',
            addressNumber: '',
            addressComplement: '',
            district: '',
            city: '',
            state: '',
            proposalNumber: 0,
            contractNumberS4: '',
            responsibility: '',
            cardNumber: '',
            cardValidity: '',
            cardFlag: '',
            cardCvc: '',
            cardDayExpiration: -1,
            dateSignatureContract: '',
            formOfPaymentId: '',
            formOfPayment: '',
            firstName: '',
            lastName: '',
            dateOfBirth: '',
            gender: null,
            maritalStatus: null,
            cpf: '',
            motherName: '',
            susNumber: '',
            plansId: '',
            nsu: '',
            autorizacaoCodigo: '',
            paymentId: '',
            TypeFm: 'FISICA',
            protocoloCancelamento: '',
            vendedor: '',
            CPFVendedor: '',
            matricula: '',
            stageForm: 2,
            tempPassword: false,
            originRegister: 'EXTERNO',
            existSales: '',
            salesmanId: '5cc0a27ee2cead066040bfc9',
            brokerId: '5cc0a118e2cead066040bfc6',
            qtdDependentes: '',
            situacaoBoleto: '',
            modalidadePagamento: '',
            cidadeId: '',
            cepLocalizado: true,
            reteveAdesao: false,
          },
          validarEmail: true,
          validarDataNascTit: true,
          validarDataNascDep: true,
          idBoleto: '',
          Sales: {
            status: 'PAGAMENTO PENDENTE',
            fMIPConfirm: '',
            fMConfirm: '',
            salesmanIPConfirm: '',
            financialManagerId: '',
            salesmanId: '',
            brokerId: '',
            salesmanConfirm: '',
            paymentId: '',
            boletoId: '',
            nsu: '',
            autorizacaoCodigo: ''
          },
          validadeCartaoAno: '',
          modelCartao: {
            id: '',
            valor: '',
            tipoTransacao: 'A_VISTA',
            quantidadeParcelas: 1,
            comprador: {
              id: '',
              documentoNumero: '',
              documentoTipo: '1',
              email: '',
              nomeCompleto: '',
              primeiroNome: '',
              ultimoNome: '',
              enderecoLogradouro: '',
              enderecoNumero: '',
              enderecoComplemento: '',
              enderecoCep: '',
              enderecoBairro: '',
              enderecoCidade: '',
              enderecoEstado: '',
            },
            cartao: {
              numero: '',
              codigoSeguranca: '',
              nome: '',
              expiracaoAno: '',
              expiracaoMes: '',
              bandeira: '',
              incluirCofre: true,
            }
          },
          defaltModelCartao: {
            id: '',
            valor: '',
            tipoTransacao: 'A_VISTA',
            quantidadeParcelas: 1,
            comprador: {
              id: '',
              documentoNumero: '',
              documentoTipo: '1',
              email: '',
              nomeCompleto: '',
              primeiroNome: '',
              ultimoNome: '',
              enderecoLogradouro: '',
              enderecoNumero: '',
              enderecoComplemento: '',
              enderecoCep: '',
              enderecoBairro: '',
              enderecoCidade: '',
              enderecoEstado: '',
            },
            cartao: {
              numero: '',
              codigoSeguranca: '',
              nome: '',
              expiracaoAno: '',
              expiracaoMes: '',
              bandeira: ''
            }
          },
          steppers: {
            default: 0,
            type: Number
          },
          formOfPayment: {
            costCenterId: '',
            dayInclusion: '',
            type: ''
          },
          idUf: '',
          idUser: '',
          planosDiferentes: false,
          dialogoPagamentoIframe: false,
          gatewayPagamento : '',
          urlIframe : '',
          dialogoTipoPagamento: false,
          dialogoPix: false,
          pagamentoTipoBoleto: '',
          responseBoleto: {
            BoletoID: '',
            LinhaDigitavel: '',
            Valor: '',
            Vencimento: '',
          },
          responsePix: {
            link: '',
            qrCode: '',
            valor: '',
          },
          dialogoBoleto: false,
          impressaoBoleto: false,
          dialogoUsaCupom: false,
          dictionary: {
            custom: {
              uf: {
                required: () => 'Informe a UF',
              },
              firstName: {
                required: () => 'Informe nome e sobrenome', 
                regex: () => 'Informe nome e sobrenome'                    
              },
              firstNameDep: {
                required: () => 'Informe nome e sobrenome', 
                regex: () => 'Informe nome e sobrenome'                    
              },
              email: {
                required: () => 'Informe o Email',
                email: () => 'Informe um Email válido'
              },
              password: {
                required: () => 'Informe a Senha',
                confirmed: () => 'A senha não confere'
              },
              senha: {
                required: () => 'Informe a Senha'
              },
              dateOfBirth: {
                required: () => 'Informe a Data de Nascimento' ,
                date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
              },
              dateOfBirthDep: {
                required: () => 'Informe a Data de Nascimento',
                date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
              },
              gender: {
                required: () => 'Informe o Sexo' 
              },
              genderDep: {
                required: () => 'Informe o Sexo' 
              },
              maritalStatus: {
                required: () => 'Informe o Estado Civil' 
              },
              maritalStatusDep: {
                required: () => 'Informe o Estado Civil' 
              },
              motherName:{
                required: () => 'Informe o nome da Mãe',
                regex: () => 'Informe nome e sobrenome'
              },
              motherNameDep:{
                required: () => 'Informe o nome da Mãe',
                regex: () => 'Informe nome e sobrenome'
              },
              cep:{
                required: () => 'Informe o CEP'
              },
              numero: {
                required: () => 'Informe o Número, caso não tenha informe 1'
              },
              parentage: {
                required: () => 'Informe o Parentesco'
              },
              cpfDep: {
                required:() => 'Informe o CPF'
              },
              nomeCompCartao: {
                required: () => 'Informe o Nome',                   
              },
              emailCartao: {
                required: () => 'Informe o Email',
                email: () => 'Informe um Email válido'
              },
              cpfCartao: {
                required:() => 'Informe o CPF'
              },
              priNomeCartao: {
                required:() => 'Informe o Primeiro Nome'
              },
              ultNomeCartao: {
                required:() => 'Informe o Último Nome'
              },
              cepCartao: {
                required: () => 'Informe o CEP'
              },
              ruaCartao: {
                required: () => 'Informe a Rua'
              },
              numeroCartao: {
                required: () => 'Informe o Número, caso não tenha informe 1'
              },
              bairroCartao: {
                required: () => 'Informe o Bairro'
              },
              cidadeCartao: {
                required: () => 'Informe a Cidade'
              },
              estadoCartao: {
                required: () => 'Informe o Estado'
              },
              numCartao: {
                required: () => 'Informe o número do cartão de crédito',
                credit_card:() => 'Número de Cartão Inválido'
              },
              bandeiraCartao: {
                required:() => 'Informe a bandeira'
              },
              nomeCartao: {
                required: () => 'Informe o nome'
              },
              codCartao: {
                required: () => 'Informe o código de segurança'
              },
              expiraCartaoMes: {
                required: () => 'Informe o mês de validade do cartão',
              },
              expiraCartaoAno: {
                required: () => 'Informe o ano de validade do cartão',
              },
              carteirinha: {
                required: () => 'Informe o número da carteirinha'
              },
              rg: {
                required: () => 'Informe o número do RG'
              },
              rgEmissor: {
                required: () => 'Informe o Órgão Expedidor do RG'
              },
              Celular: {
                required: () => 'Informe o número do Celular'
              },
              agenciaDeb: {
                required: () => 'Informe o número da Agência'
              },
              contaDeb: {
                required: () => 'Informe o número da Conta'
              },
              bancoDeb: {
                required: () => 'Informe o nome do Banco'
              },
              selecaoplan: {
                required: () => 'Necessário selecionar o plano'
              },
              estados: {
                required: () => 'Escolha o estado'
              },
              bairros: {
                required: () => 'Escolha o bairro'
              },
              cidades: {
                required: () => 'Escolha a cidade'
              }
            }
          }
        }
      },

      mounted: async function(){
        this.carregaDados()        
        this.pegaParametrosUrl()
        this.gatewayPagamento = await this.pegaInformacoesOperadora('gatewayPagamento')

        if (sessionStorage.getItem('FinancialManager') != null) {
          this.continuaProposta()
        } else {
          this.planoSelecionado = JSON.parse(localStorage.getItem('planoSelecionado'))
          this.tipoPagamento = this.planoSelecionado.typePayment
          this.selecaoPlano = this.planoSelecionado.id
          this.dependents.namePlan = this.planoSelecionado.name
          this.pdfSelecionado = this.planoSelecionado.urlContrato
        }

        if (sessionStorage.getItem('cidadeId') != null) {
          this.financialManagers.cidadeId = parseInt(sessionStorage.getItem('cidadeId'))
        }

        if(sessionStorage.getItem('Vendedor') != null){
          this.vendedorLink = JSON.parse(sessionStorage.getItem('Vendedor'))
          this.temVendedor = true
          this.linkVendedor = true
          this.nomeVendedor = this.vendedorLink.linkSite
          this.financialManagers.vendedor = this.vendedorLink.linkSite
          this.financialManagers.CPFVendedor = this.vendedorLink.cpf.replace(/[^\d]+/g,'')
          this.financialManagers.salesmanId = this.vendedorLink.id  
          this.financialManagers.brokerId = this.vendedorLink.brokerId            
        }

        this.$validator.localize('pt', this.dictionary)
        this.$store.dispatch('Logar')
        //this.valorTotalProposta = parseFloat(this.planoSelecionado.value) /* + parseFloat(this.valorTaxaImplantacao) */ 
      },

      beforeDestroy() {
        this.valorDependentes = 0
      },

      watch: {
        dialog(val) {
          val || this.close()
        },

        cupomAplicado(val){
          if (val == false)
            this.excluiCupom()
        }
      },

      computed: {
        formTitle() {
          return this.editedIndex === '' ? 'Incluir Dependente' : 'Editar Dependente'
        },

        formTitleTitular() {
          return this.editedIndexTitular === '' ? 'Incluir Titular' : 'Editar Titular'
        }
      },

      methods: {
        async pegaInformacoesOperadora(atributo) {
          let vm = this;
          let informacao = ''
          this.isLoading = true

          await axios.get(baseApiUrl + 'Operadoras?filter={"fields":{"' + atributo + '": true}}')
          .then(response => {
            if (response.data) {
              informacao = response.data[0][atributo]
            }
          })
          .catch(() => {
            // eslint-disable-next-line
            console.error('não conseguiu obter gatewayPagamento na Operadora');
            vm.$refs.chamaSnackbar.snack("red", "Problema ao obter configuração. Recarregue a página.", "DESCULPE")
          })

          this.isLoading = false

          return informacao
        },

        informacaoOperadora(atributo) {
          return operadora[atributo]
        },

        editItem(item) {
          this.editedIndex = item.id
          this.editedIndexTitular = item.id
          this.selecaoPlano = item.plansId
          this.dependents = Object.assign({}, item)
          this.dataNascDependent = this.formatDateBrz(this.dependents.dateOfBirth)
          if (item.isHolder == true)
            this.tipoTitular = true
          else
            this.tipoTitular = false
          this.dialog = true
        },

        async continuaProposta() {
          this.isLoading = true         
          if (sessionStorage.getItem('FinancialManager') != null) {
            this.financialManagers = JSON.parse(sessionStorage.getItem('FinancialManager') || '[]')
            //this.planoSelecionado = this.financialManagers.planoSelecionado
            this.idUser = this.financialManagers.id
            this.dataNasc = this.formatDateBrz(this.financialManagers.dateOfBirth)        
            if (!this.financialManagers.contratanteTitular && this.financialManagers.stageForm >= 6)
              this.existeTitular = true
            else
              this.existeTitular = false

            //Carrega as informações do Plano
            try {
              let res = await axios.get(`${baseApiUrl}Plans?filter[where][id]=${this.financialManagers.plansId}`) 
              if (res.data != '') {
                this.planoSelecionado = res.data[0] 
                this.pdfSelecionado = this.planoSelecionado.urlContrato 
                this.selecaoPlano = this.financialManagers.plansId
              }
              this.tipoPagamento = this.planoSelecionado.typePayment
              this.selecaoPlano = res.data[0].id
              this.dependents.namePlan = res.data[0].name              
            } catch (error) {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao carregar plano","ERRO");
            }

            //carrega planos disponíveis para o contratante
            await this.carregaDados()

            //Carrega as informações do Vendedor
            if (this.financialManagers.vendedor != '') {
              try {
                let res = await axios.get(`${baseApiUrl}Salesmans/infoPublico?linkSite=${this.financialManagers.vendedor}`) 
                if (res.data != '') {
                  this.vendedorLink = res.data[0] 
                  this.temVendedor = true
                  this.linkVendedor = true
                  this.nomeVendedor = this.vendedorLink.linkSite  
                  this.financialManagers.salesmanId = this.vendedorLink.id  
                  this.financialManagers.brokerId = this.vendedorLink.brokerId 
                }              
              } catch (error) {
                this.isLoading = false
                vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao carregar dados do vendedor","ERRO");
              } 
            }
            
            //carregar endereço
            //this.retornoCEP()
            
            //Carrega estagio do Cadastro
            switch (this.financialManagers.stageForm) {
              case 2: 
                this.e1 = 2
                break;
              case 3:
                this.e1 = 3
                break;
              case 4:
                this.e1 = 4
                break;
              case 5:
                await this.carregaDependentes()
                this.e1 = 5
                //this.avancaPasso5()
                break;
              case 6:
                await this.carregaDependentes()
                await this.avancaPasso6()               
                break;
              default:
                break;
            }
            this.isLoading = false
          }
        },

        async deleteDependente() {
          await axios.post(baseApiUrl + 'Dependents/excluir', {"id": this.editedIndex})
          .then(() => {
            this.carregaDependentes()
            this.close()                
          })
          .catch(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao excluir dependente","ERRO");              
            this.close()
          })
        },

        async carregaDados() {
          this.$validator.localize('pt', this.dictionary)
          await axios.get(`${baseApiUrl}UFs`).then(res => {
            if (res.data != null) {
              this.estados = res.data
              for (let i = 0; i < res.data.length; i++) {
                this.estadosSelect.push({
                  value: res.data[i].codeS4,
                  text: res.data[i].name.toUpperCase()
                })
              }
            }
          })
          try {
            let tipoConsulta
            if (this.tipoPagamento == 'BOLETO')
              tipoConsulta = 'BOLETO'
            else
              tipoConsulta = 'CARTAO'
            this.planos = []
            let res = await axios.get(`${baseApiUrl}Plans?filter={"where":{"and":[{"qualificacao":{"inq":["Individual","Familiar"]}},{"publico":"Pessoa Física"},{"typePayment":"${tipoConsulta}"}]}}`)
            for (var key in res.data) {
              if (res.data.hasOwnProperty(key)) {
                this.planos.push({
                  'codeS4': res.data[key].codeS4,                  
                  'familyTable': res.data[key].familyTable,
                  'id': res.data[key].id,
                  'name': res.data[key].name,                   
                  'value': res.data[key].value,
                  'descricao': res.data[key].name + " - R$" + res.data[key].value
                });
              }
            }
          } catch (error) {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao consultar os planos","ERRO");
          }
        },

        selecionaPlanoDepend(){
          for (var i=0; i<this.planos.length; i++) {
            if (this.planos[i].id === this.selecaoPlano) {
              this.dependents.plansId = this.planos[i].id
              this.dependents.valuePlan = this.planos[i].value
              this.dependents.namePlan = this.planos[i].name           
            }
          }
        },

        async salvarPrimeiroAcesso() {
          await this.$validator.validate('email').then(valid => {
            if (!valid)
              this.validarEmail = false
            else
              this.validarEmail = true
          });

          if (this.financialManagers.email == '' || this.financialManagers.firstName == '' || this.financialManagers.password == '' || this.financialManagers.cpf == '' || this.financialManagers.confirmPassword == '' || this.financialManagers.cellPhone == '' || this.financialManagers.password != this.financialManagers.confirmPassword || !this.validarEmail)
            this.$validator.validateAll()
          else {
            this.isLoading = true 
            var verificaemail = ''
            var verificaCancelamento

            await axios.post(baseApiUrl + 'FinancialManagers/proposta', {"email": this.financialManagers.email}).then(res => {
              if (res.data != '') {
                verificaemail = res.data[0].email
                verificaCancelamento = res.data[0].protocoloCancelamento  
              }              	
            })
            if (verificaemail == '' || verificaCancelamento != '') {
              //this.financialManagers.planoSelecionado = this.planoSelecionado 
              this.financialManagers.plansId = this.planoSelecionado.id 
              this.financialManagers.firstName = this.financialManagers.firstName.toUpperCase()
              this.financialManagers.email = this.financialManagers.email.toLowerCase()               
              await axios.post(baseApiUrl + 'FinancialManagers/editaProposta', this.financialManagers).then(async res => {
                if (res.data != '') {
                  this.financialManagers.id = res.data.id
                  this.idUser = res.data.id
                  this.$validator.reset()
                  this.financialManagers.proposalNumber = await this.geraNumeroProposta(this.idUser)
                  this.financialManagers.stageForm = 2
                  this.e1 = 2   
                  this.salvarFinancialManager()
                  this.isLoading = false                 
                }              	
              })
            } else {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#F9A825","Já existe um cadastro para esse email, acesse a Área do Cliente!","ATENÇÃO")
            }
          } 
        },

        async avancaPasso3() {
          await this.$validator.validate('dateOfBirth').then(valid => {
            if (!valid)
              this.validarDataNascTit = false
            else
              if (this.calculateAge(this.dataNasc) >= 18) {
                this.validarDataNascTit = true
              } else {
                this.validarDataNascTit = false
                var vm2 = this;
                vm2.$refs.chamaSnackbar.snack("#F9A825", "Responsável Financeiro não pode ser menor de 18 anos!", "ATENÇÃO")
              }
          });

          if (this.dataNasc == '' || /* this.financialManagers.maritalStatus == null || */ this.financialManagers.gender == null || this.financialManagers.cpf == '' || this.financialManagers.motherName == '' || !CpfValidate(this.financialManagers.cpf) || /* this.financialManagers.rg == '' || this.financialManagers.rgEmitter == '' || */ !this.validarDataNascTit)
            this.$validator.validateAll()
          else {
            this.isLoading = true
            await axios.post(`${baseApiUrl}APIS4s/Associados`, {"cpf": this.financialManagers.cpf.replace(/\D/g, ''),"empresa": 0,"incluirDependentes":1}).then(res => {
              if (res.data.Data.length > 0) {
                res.data.Data.forEach( (titular) => {
                  if (titular.Dependente[0].Situacao == "1") {
                    this.verificaTitularS4e = true
                  } else {
                    this.verificaTitularS4e = false
                  }
                })
              } else {
                this.verificaTitularS4e = false
              }              
            })         
            this.financialManagers.dateOfBirth = this.formatDate(this.dataNasc)
            await axios.post(baseApiUrl + 'FinancialManagers/editaProposta', this.financialManagers).then(res => {
              if (res.data != '') {
                if (this.financialManagers.contratanteTitular && !this.verificaTitularS4e) {
                  this.dependents.valuePlan = this.planoSelecionado.value
                  this.dependents.rcaId = '8'
                  this.dependents.dateFirstPayment = new Date().toISOString().substr(0, 7).replace('-','')
                  this.dependents.isHolder = true
                  this.dependents.financialManagerId = this.idUser
                  this.dependents.firstName = this.financialManagers.firstName
                  this.dependents.dateOfBirth = this.financialManagers.dateOfBirth
                  this.dependents.gender = this.financialManagers.gender
                  this.dependents.maritalStatus = this.financialManagers.maritalStatus
                  this.dependents.cpf = this.financialManagers.cpf
                  this.dependents.motherName = this.financialManagers.motherName
                  this.dependents.susNumber = this.financialManagers.susNumber
                  this.dependents.plansId = this.planoSelecionado.id
                  this.salvarTitular()
                  this.financialManagers.stageForm = 3
                  this.e1 = 3
                  this.isLoading = false
                  this.alertTitular = false
                  this.radioBTtitular = false
                  this.$validator.reset()
                } else if(!this.financialManagers.contratanteTitular) {
                  this.e1 = 3
                  this.financialManagers.stageForm = 3
                  this.isLoading = false
                  this.alertTitular = !this.financialManagers.contratanteTitular
                  this.radioBTtitular = false
                  this.$validator.reset()
                } else {
                  this.isLoading = false
                  var vm2 = this;
                  vm2.$refs.chamaSnackbar.snack("#F9A825","Não foi possível incluir o Titular, já existe um contrato ativo para esse CPF!","ATENÇÃO")
                }
              }
            })
            await axios.post(baseApiUrl + 'FinancialManagers/proposta', {"id": this.idUser}).then(res => {
              if (res.data.dependentes.length > 0) {
                this.existeTitular = true
                this.alertTitular = false
              }
            })
          }
        },

        async salvarFinancialManager() {
          try {
            let res = await axios.post(baseApiUrl + 'FinancialManagers/editaProposta', this.financialManagers ) 
            if (res.data != '') {
              //
            }
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro Salvar Responsável Financeiro","ERRO");
          }
        },

        async avancaPasso4() {
          this.isLoading = true
          this.Anexos.id = this.idUser
          this.Anexos.imagesDocs.rg = document.getElementById("rg1").value
          this.Anexos.imagesDocs.rg2 = document.getElementById("rg2").value
          this.Anexos.imagesDocs.cpf = document.getElementById("cpf").value
          this.Anexos.imagesDocs.address = document.getElementById("address").value
          this.Anexos.imagesDocs.others = document.getElementById("outros").value
            
          /* if(this.Anexos.imagesDocs.rg == undefined || this.Anexos.imagesDocs.rg2 == undefined || this.Anexos.imagesDocs.cpf == undefined || this.Anexos.imagesDocs.address == undefined || this.Anexos.imagesDocs.others == undefined){
            this.isLoading = false
            var vm2 = this;
            vm2.$refs.chamaSnackbar.snack("#F9A825","Para continuar é necessário enviar todos os arquivos","ATENÇÃO")
          } else{ */
          await axios.post(`${baseApiUrl}ImagesDocs/saveDocsFinancialManager`,this.Anexos )
          .then(res => {
            if (res.data != '') {
              this.e1 = 4
              this.financialManagers.stageForm = 4  
              this.isLoading = false
            }
          })
          .catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao salvar Anexos, verifique os arquivos!","ERRO"); 
            return;             
          })                    
          this.salvarFinancialManager()
        },        

        async avancaPasso5() {
          if (this.financialManagers.cepLocalizado) {
            if (this.financialManagers.cep == '' || this.financialManagers.addressNumber == null || this.financialManagers.address == '' || this.financialManagers.city == '' || this.financialManagers.state == '' || this.financialManagers.district == '')
              this.$validator.validateAll()
            else {
              this.isLoading = true
              //SALVA OS DEPENDENTES QUE FORAM CARREGADOS
              if (this.qtdDependentesInseridos < this.financialManagers.qtdDependentes)
                this.salvarDependentesCarregados()
              this.financialManagers.stageForm = 5
              this.salvarFinancialManager()
              this.carregaDependentes()
              this.carregaDados()
              setTimeout(() => {
                this.e1 = 5
                this.isLoading = false
              }, 2000);
              this.$validator.reset()
              if (this.financialManagers.contratanteTitular == false && this.existeTitular == false) {
                this.openDialog()
              } else {
                this.alertTitular = false
                if (this.planoSelecionado.taxaImplantacao != '0,00') {
                  this.valorTitular = parseFloat(this.planoSelecionado.value.replace(',', '.') + parseFloat(this.planoSelecionado.taxaImplantacao).replace(',', '.')).toFixed(2)
                  this.valorTotalProposta = this.valorTitular
                } else {
                  this.valorTitular = parseFloat(this.planoSelecionado.value.replace(',', '.')).toFixed(2)
                  this.valorTotalProposta = this.valorTitular
                }
              }
            }
          } else {
            this.financialManagers.city = this.cidadeId
            this.financialManagers.state = this.estadoId
            this.financialManagers.district = this.bairroId
            if (this.financialManagers.cep == '' || this.financialManagers.addressNumber == null || this.financialManagers.address == '' || this.financialManagers.city == '' || this.financialManagers.state == '' || this.financialManagers.district == '')
              this.$validator.validateAll()
            else {
              this.isLoading = true
              //SALVA OS DEPENDENTES QUE FORAM CARREGADOS
              if (this.qtdDependentesInseridos < this.financialManagers.qtdDependentes)
                this.salvarDependentesCarregados()
              this.financialManagers.stageForm = 5
              this.salvarFinancialManager()
              this.carregaDependentes()
              setTimeout(() => {
                this.e1 = 5
                this.isLoading = false
              }, 2000);
              this.$validator.reset()
              if (this.financialManagers.contratanteTitular == false && this.existeTitular == false) {
                this.openDialog()
              } else {
                this.alertTitular = false
                if (this.planoSelecionado.taxaImplantacao != '0,00') {
                  this.valorTitular = parseFloat(this.planoSelecionado.value.replace(',', '.') + parseFloat(this.planoSelecionado.taxaImplantacao).replace(',', '.')).toFixed(2)
                  this.valorTotalProposta = this.valorTitular
                } else {
                  this.valorTitular = parseFloat(this.planoSelecionado.value.replace(',', '.')).toFixed(2)
                  this.valorTotalProposta = this.valorTitular
                }
              }
            }
          }
        },

        async carregaCidades() {
          let idEstado = ''
          for (let i = 0; i < this.estados.length; i++) {
            if (this.estadoId == this.estados[i].codeS4) {
              idEstado = this.estados[i].codeS4
            }
          }
          let res = await axios.post(`${baseApiUrl}APIS4s/Municipios`, {"idUF": parseInt(idEstado)})
          if (res.data) {
            this.cidades = []
            this.bairros = []
            for (let i = 0; i < res.data.length; i++) {
              this.cidades.push({
                value: res.data[i].Id,
                text: res.data[i].Nome
              })
            }
          }
          this.editaCidade = false
          this.editaBairro = true
        },

        async carregaBairros() {
          let idCidade = ''
          for (let i = 0; i < this.cidades.length; i++) {
            if (this.cidadeId == this.cidades[i].value) {
              idCidade = this.cidades[i].value
            }
          }
          let res = await axios.post(`${baseApiUrl}APIS4s/Bairros`, {"idCity": parseInt(idCidade)})
          if (res.data) {
            this.bairros = []
            for (let i = 0; i < res.data.length; i++) {
              this.bairros.push({
                value: res.data[i].Id,
                text: res.data[i].Nome
              })
            }
          }
          this.editaBairro = false
        },

        async avancaPasso6() {
          if (this.alertTitular) {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Para continuar é necessário informar o Titular do Plano!","ATENÇÃO")
          }
          /* else if (this.planoSelecionado.qualificacao.toUpperCase().includes('FAMILIAR') && this.qtdDependentesInseridos < 2 && this.financialManagers.matricula == '' && this.planoSelecionado.area_atuacao != 'AVANTI/PALMEIRAS' && this.planoSelecionado.area_atuacao != 'IGREJAS SP') {
            var vm2 = this;
            vm2.$refs.chamaSnackbar.snack("#F9A825","Para planos do tipo 'FAMILIAR' é necessário incluir pelo menos um dependente","ATENÇÃO")
          }  */         
          else {
            this.isLoading = true
            if (this.financialManagers.originRegister == 'INTERNO') {
              // this.valorTotalProposta = this.financialManagers.responsibility
              this.exibeVendedor = false
            } else {
              this.exibeVendedor = true
              this.financialManagers.responsibility = this.valorTotalProposta
            }
            this.financialManagers.stageForm = 6
            this.salvarFinancialManager()
            this.e1 = 6
            this.isLoading = false
          }

          //Pegando codeS4 para salvar no FinancialManager
          try {
            let res = await axios.get(`${baseApiUrl}UFs?filter={"where":{"codeS4":${this.financialManagers.state}}}`) 
            if (res.data != '') {
              this.financialManagUF = res.data[0].prefix
              this.idUf = res.data[0].id
            }              
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao consultar o estado do cliente","ERRO");
          }
          /* await axios.get(`${baseApiUrl}UFs?filter={"where":{"codeS4":${this.financialManagers.state}}}`).then(res => {        
            if (res.data != null) {
              this.financialManagUF = res.data[0].prefix
              this.idUf = res.data[0].id
            }
          }) */
        
          //pegando o ID o centro de custo
          this.pegarCostCenterUf()
        },

        //Pega o centro de custo pelo idUf
        async pegarCostCenterUf() {
          try {
            let res = await axios.get(`${baseApiUrl}CostCenters?filter[where][ufId]=${this.idUf}`) 
            if (res.data != '') {
              this.idCostCenter = res.data[0].id
            }
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro consultar o centro de custo","ERRO");
          }
        },

        async verificaTitular() {
          await axios.post(`${baseApiUrl}APIS4s/Associados`, {"cpf": this.financialManagers.cpf.replace(/\D/g, ''),"empresa": 0,"incluirDependentes":1}).then(res => {         
            if (res.data.Data.length > 0)
              this.verificaTitularS4e = true 
            else
              this.verificaTitularS4e = false         	
          })
        },

        async salvarContinuar(){
          this.financialManagers.dateOfBirth = this.formatDate(this.dataNasc)
          this.financialManagers.stageForm = this.e1
          await axios.post(baseApiUrl + 'FinancialManagers/editaProposta', this.financialManagers).then(res => {
            if (res.data != '') {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#0288D1","Informações salvas com sucesso, para continuar depois, acesse a Área do Cliente!","INFORMAÇÃO")
            }              	
          })
        },

        formatDate (date) {
          if (!date) return null

          const [day, month, year] = date.split('/')
          return `${year}-${month}-${day}`
        },

        formatDateBrz (date) {
          if (!date) return null

          const [year, month, day] = date.split('-')
          return `${day}/${month}/${year}`
        },

        formatDateCartao (date) {
          if (!date) return null

          const [year, month] = date.split('-')
          return `${month}/${year}`
        },

        async retornoCEP() {
          if (/^[0-9]{5}-[0-9]{3}$/.test(this.financialManagers.cep)) {
            try {
              let res = await axios.post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.financialManagers.cep}) 
              if (res.data) {
                await axios.get(`${baseApiUrl}UFs?filter={"where":{"codeS4":${res.data.IdUf}}}`).then(res2 => {
                  this.estado = res2.data[0].prefix
                })
                
                this.financialManagers.address = res.data.Logradouro
                this.cidade = res.data.Municipio
                this.financialManagers.city = res.data.IdMunicipio
                this.financialManagers.state = res.data.IdUf
                this.bairro = res.data.Bairro
                this.financialManagers.district = res.data.IdBairro
                this.financialManagers.addressType = res.data.IdTipoLogradouro
                this.financialManagers.addressTypeName = res.data.TipoLogradouro
                this.editaEstado = true
                this.editaRua = true
                this.editaBairro = true
                this.editaCidade = true
                this.financialManagers.cepLocalizado = true
                if (this.financialManagers.cep.substr(6, 8) == "000") {
                  this.editaRua = false
                  this.editaEstado = false
                  this.editaBairro = false
                  this.editaCidade = false
                }
              } else {
                // var vmcep = this;
                // vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                this.financialManagers.address = ''
                this.cidade = ''
                this.financialManagers.city = ''
                this.estado = ''
                this.financialManagers.state = ''
                this.bairro = ''
                this.financialManagers.district = ''
                this.financialManagers.addressType = '' 
                this.editaEstado = false
                this.editaRua = false
                this.financialManagers.cepLocalizado = false
              }             
            } catch (error) {
              // vmcep = this;
              // vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
              this.financialManagers.address = ''
              this.cidade = ''
              this.financialManagers.city = ''
              this.estado = ''
              this.financialManagers.state = ''
              this.bairro = ''
              this.financialManagers.district = ''
              this.financialManagers.addressType = '' 
              this.editaEstado = false
              this.editaRua = false
              this.financialManagers.cepLocalizado = false
            }
          }
        },

        async retornoCEPcartao() {
          if (/^[0-9]{5}-[0-9]{3}$/.test(this.modelCartao.comprador.enderecoCep)) {
            axios.post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.modelCartao.comprador.enderecoCep}).then(res => {
              if (res.data != null) {
                this.modelCartao.comprador.enderecoLogradouro = res.data.Logradouro
                this.modelCartao.comprador.enderecoCidade = res.data.Municipio
                this.modelCartao.comprador.enderecoEstado = res.data.Uf
                this.modelCartao.comprador.enderecoBairro = res.data.Bairro
              } else {
                var vmcepcart = this;
                vmcepcart.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                this.modelCartao.comprador.enderecoLogradouro = ''
                this.modelCartao.comprador.enderecoCidade = ''
                this.modelCartao.comprador.enderecoEstado = ''
                this.modelCartao.comprador.enderecoBairro = ''
              }
            })
          }
        },
        
        async retornoViaCEP() {
          if (/^[0-9]{5}-[0-9]{3}$/.test(this.financialManagers.cep)) {
            try {
              let res = await axios.get(`https://viacep.com.br/ws/${this.financialManagers.cep.replace(/[^\d]+/g,'')}/json/`) 
              if (res.data.erro == true || res.data.bairro == '' || res.data.localidade == '' || res.data.uf == '') {
                await this.retornoCEP()
              } else {
                this.cidade = res.data.localidade
                this.estado = res.data.uf
                this.bairro = res.data.bairro
              }             
            } catch (error) {
              // var vmcep = this;
              // vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
              this.cidade = ''
              this.estado = ''
              this.bairro = ''
            }
          }
        },

        async consultaVendedor() {
          if (CpfValidate(this.cpfVendedor)) {
            await axios.get(`${baseApiUrl}Salesmans/infoPublico?cpf=${this.cpfVendedor}`).then(res => {        
              if (res.data != '') {
                this.vendedorLink = res.data[0] 
                this.temVendedor = true
                //this.linkVendedor = true
                this.nomeVendedor = this.vendedorLink.linkSite 
                this.financialManagers.salesmanId = this.vendedorLink.id  
                this.financialManagers.brokerId = this.vendedorLink.brokerId             
              } else {
                var vmcpfvend = this;
                vmcpfvend.$refs.chamaSnackbar.snack("#F9A825","Vendedor não localizado","ATENÇÃO");
                this.nomeVendedor = '' 
              }
            })
          }
        },

        async carregaDependentes() {
          this.valorFaixa = parseFloat(this.planoSelecionado.value.replace(',', '.')).toFixed(2)
          this.valorPlano = this.planoSelecionado.value
          this.valorTitular = parseFloat(this.planoSelecionado.value.replace(',', '.')).toFixed(2)
          this.valorDependentes = '0,00'
          var count = 0
          var taxa = 0
          try {
            let res = await axios.post(baseApiUrl + 'FinancialManagers/proposta', {"id": this.idUser})
            if (res.data != null) {
              this.dependentes = res.data.dependentes
              this.qtdDependentesInseridos = this.dependentes.length
              if (this.dependentes.length == 1)
                this.valorDependentes = '0,00'
              for (let index = 0; index < this.dependentes.length; index++) {
                if (!this.dependentes[index].isHolder) {
                  count++
                }
              }
              taxa = count * parseFloat(this.planoSelecionado.taxaImplantacao) + parseFloat(this.planoSelecionado.taxaImplantacao) 

              for (let i = 0; i < this.dependentes.length; i++) {
                if (this.financialManagers.plansId !== this.dependentes[i].plansId) {
                  this.planosDiferentes = true
                  break;
                } else {
                  this.planosDiferentes = false
                }
              }
              if (this.planosDiferentes == false) {
                //Trata faixa de usuários
                if (count + 1 == 2 && this.planoSelecionado.familyTable.value2) {
                  this.valorFaixa = (parseFloat(this.planoSelecionado.familyTable.value2.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                  this.valorTitular = this.planoSelecionado.familyTable.value2
                  this.valorPlano = this.planoSelecionado.familyTable.value2
                  this.valorDependentes = (parseFloat(this.planoSelecionado.familyTable.value2.replace(',','.')).toFixed(2) * (count)).toFixed(2)
                  //this.descontos = (parseFloat(this.planoSelecionado.value.replace(',','.')).toFixed(2) * (count + 1) - parseFloat(this.planoSelecionado.familyTable.value2.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                } else if(count + 1 == 3 && this.planoSelecionado.familyTable.value3) {
                  this.valorFaixa = (parseFloat(this.planoSelecionado.familyTable.value3.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                  this.valorTitular = this.planoSelecionado.familyTable.value3
                  this.valorPlano = this.planoSelecionado.familyTable.value3
                  this.valorDependentes = (parseFloat(this.planoSelecionado.familyTable.value3.replace(',','.')).toFixed(2) * (count)).toFixed(2)
                  //this.descontos = (parseFloat(this.planoSelecionado.value.replace(',','.')).toFixed(2) * (count + 1) - parseFloat(this.planoSelecionado.familyTable.value2.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                } else if (count + 1 == 4 && this.planoSelecionado.familyTable.value4) {
                  this.valorFaixa = (parseFloat(this.planoSelecionado.familyTable.value4.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                  this.valorTitular = this.planoSelecionado.familyTable.value4
                  this.valorPlano = this.planoSelecionado.familyTable.value4
                  this.valorDependentes = (parseFloat(this.planoSelecionado.familyTable.value4.replace(',','.')).toFixed(2) * (count)).toFixed(2)
                  //this.descontos = (parseFloat(this.planoSelecionado.value.replace(',','.')).toFixed(2) * (count + 1) - parseFloat(this.planoSelecionado.familyTable.value2.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                } else if (count + 1 == 5 && this.planoSelecionado.familyTable.value5) {
                  this.valorFaixa = (parseFloat(this.planoSelecionado.familyTable.value5.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                  this.valorTitular = this.planoSelecionado.familyTable.value5
                  this.valorPlano = this.planoSelecionado.familyTable.value5
                  this.valorDependentes = (parseFloat(this.planoSelecionado.familyTable.value5.replace(',','.')).toFixed(2) * (count)).toFixed(2)
                  //this.descontos = (parseFloat(this.planoSelecionado.value.replace(',','.')).toFixed(2) * (count + 1) - parseFloat(this.planoSelecionado.familyTable.value3.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                } else if (count + 1 >= 6 && this.planoSelecionado.familyTable.value6) {
                  this.valorFaixa = (parseFloat(this.planoSelecionado.familyTable.value6.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                  this.valorTitular = this.planoSelecionado.familyTable.value6
                  this.valorPlano = this.planoSelecionado.familyTable.value6
                  this.valorDependentes = (parseFloat(this.planoSelecionado.familyTable.value6.replace(',','.')).toFixed(2) * (count)).toFixed(2)
                  //this.descontos = (parseFloat(this.planoSelecionado.value.replace(',','.')).toFixed(2) * (count + 1) - parseFloat(this.planoSelecionado.familyTable.value3.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                }
              } else {
                for (let i = 0; i < this.dependentes.length; i++) {
                  for (let j = 0; j < this.planos.length; j++) {
                    if (this.dependentes[i].plansId == this.planos[j].id) {
                      if (count + 1 == 2 && this.planos[j].familyTable.value2) {
                        this.dependentes[i].valuePlan = this.planos[j].familyTable.value2
                        this.valorFaixa = (parseFloat(this.planos[j].familyTable.value2.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                        if (this.dependentes[i].isHolder) {
                          this.valorTitular = this.planos[j].familyTable.value2
                        } else {
                          this.valorDependentes = (parseFloat(this.valorDependentes.replace(',','.')) + parseFloat(this.planos[j].familyTable.value2.replace(',','.'))).toFixed(2)
                        }
                        this.valorPlano = this.planos[j].familyTable.value2
                      }

                      else if (count + 1 == 3 && this.planos[j].familyTable.value3) {
                        this.dependentes[i].valuePlan = this.planos[j].familyTable.value3
                        this.valorFaixa = (parseFloat(this.planos[j].familyTable.value3.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                        if (this.dependentes[i].isHolder) {
                          this.valorTitular = this.planos[j].familyTable.value3
                        } else {
                          this.valorDependentes = (parseFloat(this.valorDependentes.replace(',','.')) +  parseFloat(this.planos[j].familyTable.value3.replace(',','.'))).toFixed(2)
                        }
                        this.valorPlano = this.planos[j].familyTable.value3
                      }

                      else if (count + 1 >= 4 && this.planos[j].familyTable.value4) {
                        this.dependentes[i].valuePlan = this.planos[j].familyTable.value4
                        this.valorFaixa = (parseFloat(this.planos[j].familyTable.value4.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                        if (this.dependentes[i].isHolder) {
                          this.valorTitular = this.planos[j].familyTable.value4
                        } else {
                          this.valorDependentes = (parseFloat(this.valorDependentes.replace(',','.')) + parseFloat(this.planos[j].familyTable.value4.replace(',','.'))).toFixed(2)
                        }
                        this.valorPlano = this.planos[j].familyTable.value4
                      }

                      else if (count + 1 >= 5 && this.planos[j].familyTable.value5) {
                        this.dependentes[i].valuePlan = this.planos[j].familyTable.value5
                        this.valorFaixa = (parseFloat(this.planos[j].familyTable.value5.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                        if (this.dependentes[i].isHolder) {
                          this.valorTitular = this.planos[j].familyTable.value5
                        } else {
                          this.valorDependentes = (parseFloat(this.valorDependentes.replace(',','.')) + parseFloat(this.planos[j].familyTable.value5.replace(',','.'))).toFixed(2)
                        }
                        this.valorPlano = this.planos[j].familyTable.value5
                      }

                      else if (count + 1 >= 6 && this.planos[j].familyTable.value6) {
                        this.dependentes[i].valuePlan = this.planos[j].familyTable.value6
                        this.valorFaixa = (parseFloat(this.planos[j].familyTable.value6.replace(',','.')).toFixed(2) * (count + 1)).toFixed(2)
                        if (this.dependentes[i].isHolder) {
                          this.valorTitular = this.planos[j].familyTable.value6
                        } else {
                          this.valorDependentes = (parseFloat(this.valorDependentes.replace(',','.')) + parseFloat(this.planos[j].familyTable.value6.replace(',','.'))).toFixed(2)
                        }
                        this.valorPlano = this.planos[j].familyTable.value6
                      }
                    }
                  }
                }
              }
              
              if (this.planoSelecionado.taxaImplantacao != '0,00') {
                this.valorTotalProposta = (parseFloat(this.valorFaixa) + parseFloat(taxa)).toFixed(2) /* + parseFloat(this.valorTaxaImplantacao) */ 
                this.valorAnualProposta = this.valorTotalProposta.replace(',','.') * 12
              } else {
                this.valorTotalProposta = (parseFloat(this.valorTitular.replace(',','.')) + parseFloat(this.valorDependentes)).toFixed(2)
                this.valorAnualProposta = this.valorTotalProposta.replace(',','.') * 12
              }
            }
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao carregar os dependentes","ERRO") 
          }
          //Verifica se existe titular
          if (this.dependentes.length > 0) {
            this.alertTitular = false
            this.existeTitular = true 
          } else {
            this.alertTitular = true
            this.existeTitular = false 
          }
        },

        async carregaFinancialManagers() {
          await axios.post(baseApiUrl + 'FinancialManagers/proposta', {"id": this.idUser}).then(res => {        
            if (res.data != null) {
              this.AtualFinancialManagers = res.data
            }
          })
        },

        async salvarTitular() {
          //this.existeTitular = false
          await axios.post(baseApiUrl + 'FinancialManagers/proposta', {"id": this.idUser}).then(res => {
            if (res.data.dependentes.length > 0) {
              this.existeTitular = true              
            }
          })

          if (!this.existeTitular) {
            await axios.post(baseApiUrl + 'Dependents/editaDependente', this.dependents).then(res => {
              if (res.data != '') {
                //this.carregaDependentes()
              }
            })
          }
        },

        async aplicaCupom() {
          var vm = this;
          if (this.financialManagers.cupomDesconto != '') {
            this.isLoading = true
            try {
              let res = await axios.post(`${baseApiUrl}Cupons/check`, {"cupom":this.financialManagers.cupomDesconto})
              this.dadosCupom = res.data            
              if (this.dadosCupom.dados == null) {
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#F9A825",this.dadosCupom.mensagem,"ATENÇÃO");
              } else {
                this.dependentes.forEach(dependente => {
                  if (this.dadosCupom.dados.tipoDesconto == "ADESÃO") {
                    this.cupomAdesao = true
                    if (this.dadosCupom.dados.planos.includes(dependente.plansId)) {
                      if (this.dadosCupom.dados.tipoValor == 'REAL') {
                        this.primeiraParcela = (parseFloat(dependente.valuePlan.replace(",",".") - this.dadosCupom.dados.valor))
                        this.valorAnualProposta = parseFloat(dependente.valuePlan.replace(',','.')) * 11
                        this.valorAnualProposta = this.valorAnualProposta + this.primeiraParcela
                        dependente.valuePlan = parseFloat(dependente.valuePlan.replace(",",".") - this.dadosCupom.dados.valor).toFixed(2).replace('.',',')
                      } else {
                        this.primeiraParcela = parseFloat(dependente.valuePlan.replace(",",".")) - (parseFloat(dependente.valuePlan.replace(",",".") * (this.dadosCupom.dados.valor / 100)))
                        this.valorAnualProposta = parseFloat(dependente.valuePlan.replace(',','.')) * 11
                        this.valorAnualProposta = this.valorAnualProposta + this.primeiraParcela
                        dependente.valuePlan = parseFloat(dependente.valuePlan.replace(",",".") - parseFloat(dependente.valuePlan.replace(",",".") * this.dadosCupom.dados.valor)/100).toFixed(2).replace('.',',')
                      }
                    } else {
                      this.isLoading = false
                      vm.$refs.chamaSnackbar.snack("#F9A825","Cupom aplicado não é disponível para o plano selecionado!","ATENÇÃO");
                    }
                  } else {
                    if (this.dadosCupom.dados.planos.includes(dependente.plansId)) {
                      if (this.dadosCupom.dados.tipoValor == 'REAL') {
                        this.valorAnualProposta = ((parseFloat(dependente.valuePlan.replace(",",".") - this.dadosCupom.dados.valor)*12) * this.dependentes.length)
                        dependente.valuePlan = parseFloat(dependente.valuePlan.replace(",",".") - this.dadosCupom.dados.valor).toFixed(2).replace('.',',')
                        this.valorDependnte = dependente.valuePlan
                      } else {
                        this.valorAnualProposta = ((parseFloat(dependente.valuePlan.replace(",",".")) * this.dependentes.length)*12)
                        this.valorAnualProposta = this.valorAnualProposta - (this.valorAnualProposta * this.dadosCupom.dados.valor / 100)
                        dependente.valuePlan = parseFloat(dependente.valuePlan.replace(",",".") - parseFloat(dependente.valuePlan.replace(",",".") * this.dadosCupom.dados.valor)/100).toFixed(2).replace('.',',')
                        this.valorDependnte = dependente.valuePlan
                      }
                    } else {
                      this.isLoading = false
                      vm.$refs.chamaSnackbar.snack("#F9A825","Cupom aplicado não é disponível para o plano selecionado!","ATENÇÃO");
                    }
                  }
                });
                this.calculaValoresCupom()
              }
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe-nos, ocorreu um erro ao consultar o cupom!","ERRO");
            }
          }
        },

        async excluiCupom() {
          this.cupomAdesao = false
          this.primeiraParcela = '0,00'
          await this.carregaDependentes()
        },

        calculaValoresCupom() {
          this.valorDependentes = '0,00'
          for (let index = 0; index < this.dependentes.length; index++) {
            if (!this.dependentes[index].isHolder) {
              this.valorDependentes = (parseFloat(this.valorDependentes) + parseFloat(this.dependentes[index].valuePlan.replace(',','.'))).toFixed(2).replace('.',',')
            } else {
              this.valorTitular = parseFloat(this.dependentes[index].valuePlan.replace(',','.')).toFixed(2).replace('.',',')
            }
          }
          this.valorTotalProposta = (parseFloat(this.valorTitular.replace(',','.')) + parseFloat(this.valorDependentes.replace(',','.'))).toFixed(2)
          this.financialManagers.responsibility = this.valorTotalProposta
          this.dependentes.forEach(dependente => {
            if (this.dadosCupom.dados.planos.includes(dependente.plansId))
              this.cupomAplicado = true
          })
          this.isLoading = false
        },

        //Métodos de Pagamento
        async pagamentoBoleto(pagamentoTipo) {
          if (this.contrataccept) {
            this.isLoading = true
            await this.retornoViaCEP()
            this.token = ''
            this.idBoleto = ''
            this.financialManagers.formOfPayment = 'BOLETO'
            /* //Pegar Token
            try {
              let res = await axios.get(`${baseApiUrl}Pagamentos/token`)
              if (res.data != '') {
                this.token = res.data.token
              }
            } catch (error) {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao se conectar com a plataforma de pagamento, tente mais tarde!","ERRO");
              this.close()                 
            } */ 
        
            //Criando data de vencimeto do boleto
            var datapagvenc = new Date();
            datapagvenc.setDate(new Date().getDate() + 3)
            var nossoNum = this.financialManagers.proposalNumber.toString() +Math.floor(10 + Math.random() * 99)
            //Preencher o campos do model de Boleto
            modelBoleto.pagadorDocumentoNumero = this.financialManagers.cpf.replace(/[^\d]+/g,'')
            modelBoleto.pagadorNome = this.financialManagers.firstName.substr(0, 39)
            modelBoleto.pagadorEndereco = this.financialManagers.address.substr(0, 39) + ', ' + this.financialManagers.addressNumber
            if (this.financialManagers.cepLocalizado) {
              modelBoleto.pagadorBairro = this.bairro.substr(0, 19)
              modelBoleto.pagadorCidade = this.cidade.substr(0, 19)
              modelBoleto.pagadorUf = this.financialManagUF 
            } else {
              modelBoleto.pagadorBairro = this.financialManagers.state
              modelBoleto.pagadorCidade = this.financialManagers.city
              modelBoleto.pagadorUf = this.financialManagUF
            }
            modelBoleto.pagadorCep = this.financialManagers.cep.replace(/[^\d]+/g,'');
            modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
            modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
            //salvando o responsibility e o valor do boleto caso seja anual
            if (pagamentoTipo == 'anual') {
              this.financialManagers.modalidadePagamento = 'ANUAL'
              if (this.financialManagers.reteveAdesao) {
                this.financialManagers.responsibility = parseFloat((this.valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*12).toFixed(2).replace(',', '.')
                modelBoleto.valorNominal = parseFloat((this.valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*11).toFixed(2).replace(',', '.')
              } else {
                this.financialManagers.responsibility = parseFloat(this.valorAnualProposta - this.planoSelecionado.descontoAnual.replace(',', '.')).toFixed(2).replace(',', '.')
                modelBoleto.valorNominal = parseFloat(this.valorAnualProposta - this.planoSelecionado.descontoAnual.replace(',', '.')).toFixed(2).replace(',', '.')
              }
            } else {
              this.financialManagers.modalidadePagamento = 'MENSAL'
              modelBoleto.valorNominal = parseFloat(this.valorTotalProposta)
            }
            modelBoleto.mensagem = 'Referente ao plano ' + this.planoSelecionado.qualificacao + " " + this.planoSelecionado.area_atuacao + " - " + this.planoSelecionado.registro + " - Proposta de Número: " + this.financialManagers.proposalNumber
            modelBoleto.nsu = this.financialManagers.proposalNumber
            modelBoleto.nossoNumero = nossoNum.substr(0,12)
            modelBoleto.seuNumero = nossoNum.substr(0,12)
          
            //Gerando o Boleto e pegando o ID
            try {
              let res = await axios.post(`${baseApiUrl}Pagamentos/boletosPost`,modelBoleto)
              if (res.data != '') {
                if (this.financialManagers.cupomDesconto) {
                  await this.salvaValorDesconto()
                  if (this.dadosCupom.dados.tipoDesconto == "ADESÃO") {
                    this.financialManagers.quantidadeParcelasDesconto = 1
                  } else {
                    this.financialManagers.quantidadeParcelasDesconto = 12
                  }
                }
                this.idBoleto = res.data.id
                await this.salvarFinancialManagerEFinalizar()
              }
            } catch (error) {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar Boleto, tente novamente!","ERRO");
              this.close()                 
            }
          } else {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Para gerar o boleto, é necessário concordar com os termos do contrato!","ATENÇÃO");
          }
        }, 

        async pagamentoBoletoEG(pagamentoTipo) {
          this.exibeBotoesPagamento = false
          var vm = this
          if (this.contrataccept) {
            this.financialManagers.formOfPayment = this.planoSelecionado.typePayment
            this.isLoading = true
            await this.retornoViaCEP()
            this.idBoleto = ''

            let dadosBoleto = {
              "Numero": this.encrypt(this.financialManagers.proposalNumber.toString()),
              "MeiosPagamentos": [
                {
                  "TipoTransacao": 10,
                  "NumeroParcelas": 1,
                  "DataPrimeiraParcela": ""
                }
              ],
              "ItensVendidos": [
                {
                  "Descricao": "Referente ao plano " + this.planoSelecionado.name + " - Proposta de Número: " + this.financialManagers.proposalNumber
                }
              ],
              "Cliente": {
                "Documento": this.financialManagers.cpf,
                "Endereco": this.financialManagers.address,
                "UF": this.financialManagUF,
                "Cidade": this.cidade,
                "Bairro": this.bairro
              }
            }

            if (pagamentoTipo == 'anual') {
              this.financialManagers.modalidadePagamento = 'ANUAL'
              this.financialManagers.responsibility = parseFloat(this.valorAnualProposta).toFixed(2).replace('.', ',')
              dadosBoleto.MeiosPagamentos[0].NumeroParcelas = 12
            } else {
              this.financialManagers.modalidadePagamento = 'MENSAL'
              this.financialManagers.responsibility = this.valorTotalProposta.replace(',','.')
            }

            this.cupomAplicado = false
            if (this.financialManagers.cupomDesconto) {
              await this.salvaValorDesconto(this.financialManagers.modalidadePagamento == 'ANUAL' ? false : true)
              if (this.dadosCupom.dados.tipoDesconto == "ADESÃO") {
                this.financialManagers.quantidadeParcelasDesconto = 1
              } else {
                this.financialManagers.quantidadeParcelasDesconto = 12
                await this.atualizaValorPlanoDep()
                if (this.pagamentoTipoCartao == 'anual' || this.pagamentoTipoCartao == 'anualParcelado') {
                  this.financialManagers.responsibility = (parseFloat(this.valorPropostaSemDesconto.replace(',','.') - this.valorTotalProposta.replace(',','.')).toFixed(2) * 12).toFixed(2)
                } else if (this.pagamentoTipoCartao == 'mensal') {
                  this.financialManagers.responsibility = parseFloat(this.valorPropostaSemDesconto.replace(',','.'))
                }
                // this.financialManagers.valorDesconto = parseFloat(this.valorPropostaSemDesconto.replace(',','.') - this.valorTotalProposta.replace(',','.')).toFixed(2)
              }
            } else {
              await this.carregaDependentes()
            }

            await this.salvarFinancialManager()

            await axios.post(baseApiUrl + 'Pagamentos/boletosPostEG', dadosBoleto)
            .then(response => {
              if (response.data) {
                if (response.data.BoletoID) {
                  this.idBoleto = response.data.BoletoID
                  this.responseBoleto = response.data
                } else {
                  this.Sales.status = 'EM VALIDAÇÃO'
                }

                this.salvarFinancialManagerEFinalizar()
              }
            })
            .catch(() => {
              this.exibeBotoesPagamento = true
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar boleto, tente novamente!","DESCULPE");
              this.close()
            })
          } else {
            if (this.financialManagers.originRegister == 'INTERNO') {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#F9A825","Para gerar o boleto, é necessário concordar com os termos do contrato, selecionar a melhor data de vencimento e inserir os dados do tutor!","ATENÇÃO");
            } else {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#F9A825","Para gerar o boleto, é necessário concordar com os termos do contrato e selecionar a melhor data de vencimento!","ATENÇÃO");
            }
          }
        },

        async imprimirBoletoEG(boletoId) {
          let vm = this
          this.impressaoBoleto = true
          
          await axios.post(baseApiUrl + 'Pagamentos/pdfBoletoEG', {"boletoId": boletoId})
          .then(response => {
            if (response.data.url) {
              this.impressaoBoleto = false
              window.open(response.data.url)
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#F9A825","Problema ao imprimir boleto. Tente novamente!","DESCULPE");
          })
        },

        async pagarPixEG(pagamentoTipo) {
          this.exibeBotoesPagamento = false
          var vm = this
          if (this.contrataccept) {
            this.isLoading = true
            await this.retornoViaCEP()

            let dadosPix = {
              "Numero": this.encrypt(this.financialManagers.proposalNumber.toString()),
              "MeiosPagamentos": [
                {
                  "TipoTransacao": 10,
                  "NumeroParcelas": 1,
                  "DataPrimeiraParcela": ""
                }
              ],
              "ItensVendidos": [
                {
                  "Descricao": "Referente ao plano " + this.planoSelecionado.name + " - Proposta de Número: " + this.financialManagers.proposalNumber
                }
              ],
              "Cliente": {
                "Documento": this.financialManagers.cpf,
                "Endereco": this.financialManagers.address,
                "UF": this.financialManagUF,
                "Cidade": this.cidade,
                "Bairro": this.bairro
              }
            }

            if (pagamentoTipo == 'anual') {
              this.financialManagers.modalidadePagamento = 'ANUAL'
              this.financialManagers.responsibility = parseFloat(this.valorTotalPropostaComDesconto * 12).toFixed(2).replace('.', ',')
              dadosPix.MeiosPagamentos[0].NumeroParcelas = 12
            } else {
              this.financialManagers.modalidadePagamento = 'MENSAL'
              this.financialManagers.responsibility = this.valorTotalProposta.replace(',','.')
            }

            this.cupomAplicado = false
            if (this.financialManagers.cupomDesconto) {
              await this.salvaValorDesconto(this.financialManagers.modalidadePagamento == 'ANUAL' ? false : true)
              if (this.dadosCupom.dados.tipoDesconto == "ADESÃO") {
                this.financialManagers.quantidadeParcelasDesconto = 1
              } else {
                this.financialManagers.quantidadeParcelasDesconto = 12
                await this.atualizaValorPlanoDep()
                // this.financialManagers.valorDesconto = parseFloat(this.valorPropostaSemDescon to.replace(',','.') - this.valorTotalProposta.replace(',','.')).toFixed(2)
              }
            } else {
              await this.carregaDependentes()
            }

            await this.salvarFinancialManager()

            this.Sales.status = 'PAGAMENTO PENDENTE'
            this.Sales.fMIPConfirm = await this.pegaIp()
            this.Sales.salesmanIPConfirm = await this.pegaIp()
            this.Sales.brokerId = this.financialManagers.brokerId
            this.Sales.salesmanId = this.financialManagers.salesmanId
            this.Sales.financialManagerId = this.idUser
            this.Sales.fMConfirm = new Date().toISOString()
            this.Sales.salesmanConfirm = new Date().toISOString()
            await axios.post(baseApiUrl + 'FinancialManagers/setExistSales', this.Sales)
            this.financialManagers.existSales = true

            await axios.post(baseApiUrl + 'Pagamentos/pixPostEG', dadosPix)
            .then(async response => {
              if (response.data) {
                this.responsePix = response.data
                this.dialogoPix = true
                this.dialogoTipoPagamento = false
                this.isLoading = false

                this.financialManagers.dateSignatureContract = new Date().toISOString().substring(0, 10)
                this.financialManagers.contractNumberS4 = await this.pegaFormOfPayment()
                this.financialManagers.formOfPayment = 'PIX'
                this.financialManagers.vendedor = this.nomeVendedor

                this.salvarFinancialManager()
              }
            })
            .catch(() => {
              this.exibeBotoesPagamento = true
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao gerar Pix, tente novamente!","DESCULPE");
              this.close()
            })
          } else {
            if (this.financialManagers.originRegister == 'INTERNO') {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#F9A825","Para gerar o boleto, é necessário concordar com os termos do contrato, selecionar a melhor data de vencimento e inserir os dados do tutor!","ATENÇÃO");
            } else {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#F9A825","Para gerar o boleto, é necessário concordar com os termos do contrato e selecionar a melhor data de vencimento!","ATENÇÃO");
            }
          }
        },
        
        async atualizaValorPlanoDep() {
          this.dependentes.forEach(async dependente => {
            try {
              dependente.dateFirstPayment = new Date().toISOString().substr(0, 7).replace('-','')
              await axios.post(baseApiUrl + 'Dependents/editaDependente', dependente)
            } catch (error) {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao atualizar valor do plano para os dependentes!","ERRO");
            }
          })
        },

        
        pagamentoCartao(pagamentoTipo) {
          if (this.financialManagers.reteveAdesao && pagamentoTipo == 'mensal')
            this.pegaDadosCartao = true
          else
            this.pegaDadosCartao = false
          
          if (this.contrataccept) {
            this.validadeCartao = ''
            this.pagamentoTipoCartao = pagamentoTipo
            this.dialogCartao = true
          } else {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Para realizar o pagamento, é necessário concordar com os termos do contrato!","ATENÇÃO");
          }
        },

        async pagarDebito() {
          if (this.financialManagers.bancoDeb == '' || this.financialManagers.agenciaDeb == '' || this.financialManagers.contaDeb == '' || this.financialManagers.diaDeb == '') {
            this.isLoading = false
            this.$validator.validateAll()
            /* var vm = this
            vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todos os dados do cartão corretamente!","ATENÇÃO"); */
          } else {
            this.isLoading = true
            if (this.pagamentoTipoCartao == 'anual') {
              this.financialManagers.modalidadePagamento = 'ANUAL'
              this.financialManagers.responsibility = parseFloat((this.valorTotalProposta*12) - ((this.valorTotalProposta*12)*10/100)).toFixed(2).replace('.', ',')
            } else {
              this.financialManagers.modalidadePagamento = 'MENSAL'
            }
            this.Sales.status = 'EM AVERBAÇÃO'
            this.financialManagers.dateSignatureContract = new Date().toISOString().substr(0, 10)
            this.financialManagers.vendedor = this.nomeVendedor
            this.financialManagers.tipoPagamento = 52
            this.formOfPayment.costCenterId = this.planoSelecionado.costCenterId
            this.formOfPayment.dayInclusion = parseInt(new Date().toISOString().substr(8, 2).replace(/^(0+)(\d)/g,"$2"))
            if (this.financialManagers.modalidadePagamento == 'ANUAL') {
              this.formOfPayment.type = this.planoSelecionado.typeFormOfPaymentAnual
            } else {
              if (this.dependentes.length >= 3) {
                this.formOfPayment.type = this.planoSelecionado.typeFormOfPayment + '_FAMILIAR'
              } else {
                this.formOfPayment.type = this.planoSelecionado.typeFormOfPayment + '_INDIVIDUAL'
              }
            }
            this.financialManagers.formOfPayment = 'DEBITO'
            if (this.dadosCupom.dados != null)
              if (this.dadosCupom.dados.tipoDesconto == 'CONTRATO')
                await this.atualizaValorPlanoDep()
            await this.salvarFinancialManagerEFinalizar()
          }
        },

        async pagarCartao() {
          if (!this.cartaValidado) {
            if (!this.modelCartao.cartao.bandeira) {
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Bandeira do cartão não localizada. Por favor, revise os dados!","ERRO");
            } else if (this.modelCartao.cartao.numero == '' || this.modelCartao.cartao.bandeira == '' || this.modelCartao.cartao.nome == '' || this.modelCartao.cartao.codigoSeguranca == '' || this.modelCartao.cartao.expiracaoMes == '' || this.validadeCartaoAno == '') {
              this.$validator.validateAll()
            } else {
              this.isLoading = true
              await this.retornoViaCEP()
              var primeiroUltimoNome = this.financialManagers.firstName.trim().split(" ") 
              this.modelCartao.id = this.encrypt(this.financialManagers.proposalNumber.toString())
              if (this.pagamentoTipoCartao == 'anual') {
                this.modelCartao.tipoTransacao = 'A_VISTA'
                this.financialManagers.modalidadePagamento = 'ANUAL'
                if (this.financialManagers.reteveAdesao) {
                  this.financialManagers.responsibility = parseFloat((this.valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*12).toFixed(2).replace(',', '.')
                  this.modelCartao.valor = parseFloat((this.valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*11).toFixed(2).replace(',', '.')
                } else {
                  this.financialManagers.responsibility = parseFloat((this.valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*12).toFixed(2).replace(',', '.')
                  this.modelCartao.valor = parseFloat((this.valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*12).toFixed(2).replace(',', '.')
                }
              } else if (this.pagamentoTipoCartao == 'anualParcelado') {
                this.modelCartao.tipoTransacao = 'PARCELADO_SEM_JUROS'
                this.financialManagers.modalidadePagamento = 'ANUAL'
                if (this.financialManagers.reteveAdesao) {
                  this.modelCartao.quantidadeParcelas = 11
                  this.financialManagers.responsibility = parseFloat((this.valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*12).toFixed(2).replace(',', '.')
                  this.modelCartao.valor = parseFloat((this.valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*11).toFixed(2).replace(',', '.')
                } else {
                  this.modelCartao.quantidadeParcelas = 12
                  this.financialManagers.responsibility = parseFloat(this.valorAnualProposta - this.planoSelecionado.descontoAnual.replace(',', '.')).toFixed(2).replace(',', '.')
                  this.modelCartao.valor = parseFloat(this.valorAnualProposta - this.planoSelecionado.descontoAnual.replace(',', '.')).toFixed(2).replace(',', '.')
                }
              } else if(this.pagamentoTipoCartao == 'mensal') {
                this.modelCartao.tipoTransacao = 'A_VISTA'
                this.financialManagers.modalidadePagamento = 'MENSAL'
                this.modelCartao.valor = this.valorTotalProposta
              }
              this.modelCartao.comprador.id = this.idUser.replace(/[^\d]+/g,'').substr(0, 9)
              this.modelCartao.comprador.documentoNumero = this.financialManagers.cpf.replace(/[^\d]+/g,'')
              this.modelCartao.comprador.documentoTipo = '1'
              this.modelCartao.comprador.email = this.financialManagers.email
              this.modelCartao.comprador.nomeCompleto = this.financialManagers.firstName
              this.modelCartao.comprador.primeiroNome = primeiroUltimoNome[0]
              this.modelCartao.comprador.ultimoNome = primeiroUltimoNome[primeiroUltimoNome.length - 1]
              this.modelCartao.comprador.enderecoLogradouro = this.financialManagers.address
              this.modelCartao.comprador.enderecoNumero = this.financialManagers.addressNumber
              this.modelCartao.comprador.enderecoComplemento = this.financialManagers.addressComplement
              this.modelCartao.comprador.enderecoCep = this.financialManagers.cep.replace(/[^\d]+/g,'')
              this.modelCartao.comprador.enderecoBairro = this.bairro
              this.modelCartao.comprador.enderecoCidade = this.cidade
              this.modelCartao.comprador.enderecoEstado = this.estado
              this.modelCartao.cartao.expiracaoAno = this.validadeCartaoAno.substr(2,4)
              //this.modelCartao.cartao.bandeira = this.getCardFlag(this.modelCartao.cartao.numero)
              this.modelCartao.cartao.bandeira = this.modelCartao.cartao.bandeira

              //Pega hash cvv e salva no FM
              try {
                let res = await axios.post(`${baseApiUrl}FinancialManagers/encrypt`,{"text": this.modelCartao.cartao.codigoSeguranca})
                if (res.data.encrypt != '')
                  this.financialManagers.cardCvc = res.data.encrypt              
              } catch (error) {
                this.isLoading = false
                vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao processar solicitação, tente mais tarde!","ERRO");
                return;
              }

              //Dados para o FM 
              this.financialManagers.cardCvc = this.encrypt(this.modelCartao.cartao.codigoSeguranca.toString())           
              this.financialManagers.cardNumber = this.modelCartao.cartao.numero
              this.financialManagers.cardValidity = this.modelCartao.cartao.expiracaoMes + this.validadeCartaoAno
              this.financialManagers.cardHolderName = this.modelCartao.cartao.nome
              this.financialManagers.cardFlag = this.modelCartao.cartao.bandeira
              this.financialManagers.dateSignatureContract = new Date().toISOString().substr(0, 10)
              this.financialManagers.vendedor = this.nomeVendedor
              this.financialManagers.formOfPayment = 'CARTAO'
              this.salvarFinancialManager()

              try {
                let res = await axios.post(`${baseApiUrl}Pagamentos/cartaocredito`, this.modelCartao) 
                if (res.data != '') {
                  
                  if (this.financialManagers.cupomDesconto) {
                    await this.salvaValorDesconto()
                    if (this.dadosCupom.dados.tipoDesconto == "ADESÃO") {
                      this.financialManagers.quantidadeParcelasDesconto = 1
                    } else {
                      this.financialManagers.quantidadeParcelasDesconto = 12
                    }
                  }
                  this.Sales.autorizacaoCodigo = res.data.transacao.autorizacaoCodigo
                  this.Sales.nsu = res.data.transacao.nsu
                  this.Sales.paymentId = res.data.pagamentoId
                  this.financialManagers.autorizacaoCodigo = res.data.transacao.autorizacaoCodigo
                  this.financialManagers.nsu = res.data.transacao.nsu
                  this.financialManagers.paymentId = res.data.pagamentoId
                  this.financialManagers.tokenCartao = res.data.cartaoId
                  this.Sales.status = 'EM VALIDAÇÃO'
                  this.financialManagers.tipoPagamento = 52
                  this.formOfPayment.costCenterId = this.planoSelecionado.costCenterId
                  this.formOfPayment.dayInclusion = parseInt(new Date().toISOString().substr(8, 2).replace(/^(0+)(\d)/g,"$2"))
                  if (this.financialManagers.modalidadePagamento == 'ANUAL') {
                    this.formOfPayment.type = this.planoSelecionado.typeFormOfPaymentAnual
                  } else {
                    if (this.dependentes.length >= 3) {
                      this.formOfPayment.type = this.planoSelecionado.typeFormOfPayment + '_FAMILIAR'
                    } else {
                      this.formOfPayment.type = this.planoSelecionado.typeFormOfPayment + '_INDIVIDUAL'
                    }
                  }
                  this.cartaValidado = true
                  if (this.cartaValidado) {
                    if (this.dadosCupom.dados != null)
                      if (this.dadosCupom.dados.tipoDesconto == 'CONTRATO')
                        await this.atualizaValorPlanoDep()
                    await this.salvarFinancialManagerEFinalizar()
                  } else {
                    this.isLoading = false
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao efetuar pagamento, " + res.data.mensagem,"ERRO") 
                  }
                }
              } catch (error) {
                this.isLoading = false
                vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao efetuar pagamento, "+error.response.data.error.mensagem,"ERRO") 
              }           
              /* await axios.post("https://p4x.srv.br/api/v1.0/pagamentos/cartaocredito",this.modelCartao, { */
            }
          }
        },

        async pagarCartaoEG(pagamentoTipoCartao) {
          var vm = this
          if (this.contrataccept) {
            this.exibeBotoesPagamento = false
            this.isLoading = true
            await this.retornoViaCEP()

            let dadosCartao = {
              "Numero": this.encrypt(this.financialManagers.proposalNumber.toString()),
              "MeiosPagamentos": [
                {
                  "TipoTransacao": 10,
                  "NumeroParcelas": 1,
                  "DataPrimeiraParcela": ""
                }
              ],
              "ItensVendidos": [
                {
                  "Descricao": "Referente ao plano " + this.planoSelecionado.name + " - Proposta de Número: " + this.financialManagers.proposalNumber
                }
              ],
              "Cliente": {
                "Documento": this.financialManagers.cpf,
                "Endereco": this.financialManagers.address,
                "UF": this.financialManagUF,
                "Cidade": this.cidade,
                "Bairro": this.bairro,
              }
            }

            if (pagamentoTipoCartao == 'anual') {
              this.financialManagers.modalidadePagamento = 'ANUAL'
              this.financialManagers.responsibility = parseFloat(this.valorAnualProposta).toFixed(2).replace('.', ',')
              this.formOfPayment.type = 'CARTAO_ANUAL'
              this.financialManagers.contractNumberS4 = await this.pegaFormOfPayment(this.formOfPayment.type)
            } else if (pagamentoTipoCartao == 'anualParcelado') {
              this.formOfPayment.type = 'CARTAO_ANUAL'
              this.financialManagers.contractNumberS4 = await this.pegaFormOfPayment(this.formOfPayment.type)
              this.financialManagers.modalidadePagamento = 'ANUAL'
              this.financialManagers.responsibility = parseFloat(this.valorAnualProposta).toFixed(2).replace('.', ',')
              dadosCartao.MeiosPagamentos[0].TipoTransacao = 2
              dadosCartao.MeiosPagamentos[0].NumeroParcelas = 12
            } else if (pagamentoTipoCartao == 'mensal') {
              this.financialManagers.modalidadePagamento = 'MENSAL'
              this.financialManagers.responsibility = this.valorTotalProposta.replace('.',',')
              if (this.dependentes.length >= 3) {
                this.formOfPayment.type = this.planoSelecionado.typeFormOfPayment + '_FAMILIAR'
              } else {
                this.formOfPayment.type = this.planoSelecionado.typeFormOfPayment + '_INDIVIDUAL'
              }
              this.financialManagers.contractNumberS4 = await this.pegaFormOfPayment(this.formOfPayment.type)
            }

            this.cupomAplicado = false
            if (this.financialManagers.cupomDesconto) {
              await this.salvaValorDesconto(this.financialManagers.modalidadePagamento == 'ANUAL' ? false : true)
              if (this.dadosCupom.dados.tipoDesconto == "ADESÃO") {
                this.financialManagers.quantidadeParcelasDesconto = 1
              } else {
                this.financialManagers.quantidadeParcelasDesconto = 12
                await this.aplicaCupom()
                await this.atualizaValorPlanoDep()
                if (this.pagamentoTipoCartao == 'anual' || this.pagamentoTipoCartao == 'anualParcelado') {
                  this.financialManagers.responsibility = (parseFloat(this.valorPropostaSemDesconto.replace(',','.') - this.valorTotalProposta.replace(',','.')).toFixed(2) * 12).toFixed(2)
                } else if (this.pagamentoTipoCartao == 'mensal') {
                  this.financialManagers.responsibility = parseFloat(this.valorPropostaSemDesconto.replace(',','.'))
                }
                // this.financialManagers.valorDesconto = parseFloat(this.valorPropostaSemDesconto.replace(',','.') - this.valorTotalProposta.replace(',','.')).toFixed(2)
              }
            } else {
              await this.carregaDependentes()
            }

            this.financialManagers.dateSignatureContract = new Date().toISOString().substring(0, 10)
            this.financialManagers.formOfPayment = 'CARTAO'
            this.Sales.status = 'PAGAMENTO PENDENTE'
            this.Sales.brokerId = this.financialManagers.brokerId
            this.Sales.salesmanId = this.financialManagers.salesmanId
            this.Sales.financialManagerId = this.idUser
            this.Sales.fMConfirm = new Date().toISOString()
            this.Sales.salesmanConfirm = new Date().toISOString()
            await axios.post(baseApiUrl + 'FinancialManagers/setExistSales', this.Sales)
            this.financialManagers.existSales = true

            if (dadosCartao.MeiosPagamentos[0].TipoTransacao == 3) {
              dadosCartao.MeiosPagamentos[0].ValorParcela = 0
              await this.dependentes.forEach(dependente => {
                dadosCartao.MeiosPagamentos[0].ValorParcela += parseFloat(dependente.valuePlan.replace(',','.'))
              })
            }

            await this.salvarFinancialManager()

            await axios.post(baseApiUrl + 'Pagamentos/cartaocreditoEG', dadosCartao)
            .then(response => {
              if (response.data) {
                this.urlIframe = response.data.url
                this.dialogoPagamentoIframe = true
                this.isLoading = false
              }
            })
            .catch(() => {
              this.exibeBotoesPagamento = true
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar cobrança no cartão de crédito, tente novamente!","DESCULPE");
            })
          } else {
            vm.$refs.chamaSnackbar.snack("#F9A825","Para realizar o pagamento, é necessário concordar com os termos do contrato e inserir os dados do tutor!","ATENÇÃO");
          }
        },

        async enviarProposta() {
          this.isLoading = true
          var vm = this;
          this.Sales.status = 'EM VALIDAÇÃO'
          if (this.planoSelecionado.typePayment == 'BOLETO') {
            if (this.contrataccept) {
              if (this.financialManagers.cupomDesconto) {
                await this.salvaValorDesconto()
                if (this.dadosCupom.dados.tipoDesconto == "ADESÃO") {
                  this.financialManagers.quantidadeParcelasDesconto = 1
                } else {
                  this.financialManagers.quantidadeParcelasDesconto = 12
                }
              }
              this.financialManagers.formOfPayment = 'BOLETO'
              await this.atualizaValorPlanoDep()
              await this.salvarFinancialManagerEFinalizar()
            } else {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825","Para concluir a proposta, é necessário concordar com os termos do contrato!","ATENÇÃO");
            }
          } else if (this.planoSelecionado.typePayment == 'CARTAO') {           
            if (!this.contrataccept) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825","Para concluir a proposta, é necessário concordar com os termos do contrato!","ATENÇÃO");
            } else if (this.modelCartao.cartao.numero == '' || this.modelCartao.cartao.nome == '' || this.modelCartao.cartao.codigoSeguranca == '' || this.modelCartao.cartao.expiracaoMes == '' || this.validadeCartaoAno == '') {
              this.$validator.validateAll()
            } else {
              this.isLoading = true
              //Pega hash cvv e salva no FM
              try {
                let res = await axios.post(`${baseApiUrl}FinancialManagers/encrypt`,{"text": this.modelCartao.cartao.codigoSeguranca})
                if (res.data.encrypt != '')
                  this.financialManagers.cardCvc = res.data.encrypt              
              } catch (error) {
                this.isLoading = false
                vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao processar solicitação, tente mais tarde!","ERRO");
                return;
              }
              this.formOfPayment.costCenterId = this.planoSelecionado.costCenterId
              this.formOfPayment.dayInclusion = parseInt(new Date().toISOString().substr(8, 2).replace(/^(0+)(\d)/g,"$2"))
              if (this.financialManagers.modalidadePagamento == 'ANUAL') {
                this.formOfPayment.type = this.planoSelecionado.typeFormOfPaymentAnual
              } else {
                if (this.dependentes.length >= 3) {
                  this.formOfPayment.type = this.planoSelecionado.typeFormOfPayment + '_FAMILIAR'
                } else {
                  this.formOfPayment.type = this.planoSelecionado.typeFormOfPayment + '_INDIVIDUAL'
                }
              }
              if (this.financialManagers.cupomDesconto) {
                await this.salvaValorDesconto()
                if (this.dadosCupom.dados.tipoDesconto == "ADESÃO") {
                  this.financialManagers.quantidadeParcelasDesconto = 1
                } else {
                  this.financialManagers.quantidadeParcelasDesconto = 12
                }
              }
              this.financialManagers.dateSignatureContract = new Date().toISOString().substr(0, 10)
              this.financialManagers.formOfPayment = 'CARTAO'
              this.financialManagers.cardNumber = this.modelCartao.cartao.numero
              this.financialManagers.cardValidity = this.modelCartao.cartao.expiracaoMes + this.validadeCartaoAno
              this.financialManagers.cardHolderName = this.modelCartao.cartao.nome
              this.financialManagers.cardFlag = this.modelCartao.cartao.bandeira
              await this.atualizaValorPlanoDep()
              await this.salvarFinancialManagerEFinalizar()
            }
          }
        },
        
        //Função para criptografia
        encrypt(text) {
          let crypto = require('crypto');
          let password = 'pxuelh2so839ljis';
          let iv = 'pxuelh2so839ljis';
          let cipher = crypto.createCipheriv('aes-128-cbc', password, iv);
          let encryptedData = cipher.update(text, 'utf8', 'Base64') + cipher.final('Base64');

          return encryptedData;
        },

        async salvarDependentesCarregados() {
          for (var i=1; i<=this.financialManagers.qtdDependentes; i++) {
            this.dependents.dateOfBirth = this.formatDate(this.dependentesCarregados[i].DataNascimento)
            this.dependents.plansId = this.planoSelecionado.id
            this.dependents.valuePlan = this.planoSelecionado.value
            this.dependents.rcaId = '8'
            this.dependents.financialManagerId = this.idUser
            this.dependents.isHolder = false
            this.dependents.firstName = this.dependentesCarregados[i].Nome
            //this.dependents.gender = this.financialManagers.gender
            //this.dependents.maritalStatus = this.financialManagers.maritalStatus
            this.dependents.cpf = this.dependentesCarregados[i].CPF
            this.dependents.motherName = this.dependentesCarregados[i].NomeMaeDependente
            this.dependents.susNumber = this.dependentesCarregados[i].CNS
            switch (this.dependentesCarregados[i].CodGrauParentesco) {
              case 3:
                this.dependents.parentage = 'CÔNJUGE'
                break;
              case 4:
                this.dependents.parentage = 'FILHO'
                break;
              case 6:
                this.dependents.parentage = 'ENTEADO'
                break;
              case 8:
                this.dependents.parentage = 'PAI/MÃE'
                break;
              case 10:
                this.dependents.parentage = 'OUTRO'
                break;          
              default:
                break;
            }      
            await axios.post(baseApiUrl + 'Dependents/editaDependente', this.dependents).then(res => {
              if (res.data != '') {
                this.carregaDependentes()
                this.dependents = Object.assign({}, this.defaultDependents)
                //this.qtdDependentesInseridos = res.data
              }              	
            })
          }
        },

        async salvarDependente() {
          await this.$validator.validate('dateOfBirthDep').then(valid => {
            if (!valid)
              this.validarDataNascDep = false
            else
              this.validarDataNascDep = true
          });
          this.dependents.dateOfBirth = this.formatDate(this.dataNascDependent)
          this.dependents.rcaId = '8'
          this.dependents.financialManagerId = this.idUser
          this.selecionaPlanoDepend()
          if (this.tipoTitular) {
            this.dependents.isHolder = true
          } else
            this.dependents.isHolder = false
          if (this.dependents.dateOfBirth == '' || this.dependents.firstName == '' || !this.validarDataNascDep || this.selecaoPlano == '')
            this.$validator.validateAll()
          else if(this.calculateAge(this.dependents.dateOfBirth) >= 12 && this.dependents.cpf == '')
            this.$validator.validateAll() 
          else if(this.dependents.isHolder == false && this.dependents.parentage == '' )
            this.$validator.validate('parentage') 
          else if(!CpfValidate(this.dependents.cpf) && this.dependents.cpf != '')
            this.$validator.validateAll() 
          else {
            //Verifica se o beneficiário é titular, se for, verifica se ele ja tem cadastro ativo.
            if (this.dependents.isHolder && this.dependents.cpf != '') {
              await axios.post(`${baseApiUrl}APIS4s/Associados`, {"cpf": this.dependents.cpf.replace(/\D/g, ''),"empresa": 0,"incluirDependentes":1}).then(res => {
                if (res.data.Data.length > 0) {
                  res.data.Data.forEach( (titular) => {
                    if (titular.Dependente[0].Situacao == "1") {
                      this.verificaTitularS4e = true
                    } else {
                      this.verificaTitularS4e = false
                    }
                  })
                } else {
                  this.verificaTitularS4e = false
                }              
              })  
            }
            if (!this.financialManagers.contratanteTitular && this.verificaTitularS4e) {
              this.isLoading = false
              var vm2 = this;
              vm2.$refs.chamaSnackbar.snack("#F9A825","Não foi possível incluir o Titular, já existe um contrato ativo para esse CPF!","ATENÇÃO")
            } else {
              this.dependents.firstName = this.dependents.firstName.toUpperCase()                          
              await axios.post(baseApiUrl + 'Dependents/editaDependente', this.dependents ).then(res => {
                if (res.data != '') {
                  this.carregaDependentes()
                  this.close()
                }              	
              })
              if (this.dependents.parentage == '') {
                this.alertTitular = false
              }
            }
          }           
        },

        async salvarFinancialManagerEFinalizar() { 
          if (this.tipoPagamento == 'BOLETO') {
            //Pegar o formOfPayment e salvar o FinancialManager
            this.financialManagers.vendedor = this.nomeVendedor
            this.financialManagers.nsu = modelBoleto.nsu
            this.financialManagers.situacaoBoleto = 'GERADO'
            this.financialManagers.nossoNumero = modelBoleto.nossoNumero
            this.financialManagers.vencimentoBoleto = modelBoleto.dataVencimento
            this.financialManagers.dateSignatureContract = new Date().toISOString().substr(0, 10)
            //this.financialManagers.proposalNumber = this.idUser.replace(/[^\d]+/g,'').substr(0, 8)+Math.floor(10 + Math.random() * 10)
            this.formOfPayment.costCenterId = this.planoSelecionado.costCenterId
            this.formOfPayment.dayInclusion = parseInt(new Date().toISOString().substr(8, 2).replace(/^(0+)(\d)/g,"$2"))
            if (this.financialManagers.modalidadePagamento == 'ANUAL') {                    
              this.formOfPayment.type = this.planoSelecionado.typeFormOfPaymentAnual
            } else {
              if (this.dependentes.length >= 3) {
                this.formOfPayment.type = this.planoSelecionado.typeFormOfPayment + '_FAMILIAR'
              } else {
                this.formOfPayment.type = this.planoSelecionado.typeFormOfPayment + '_INDIVIDUAL'
              }
            }
            this.financialManagers.formOfPayment = 'BOLETO'
            /* this.financialManagers.existSales = true  */
            this.Sales.boletoId = this.idBoleto
          }
          // this.financialManagers.formOfPayment = this.planoSelecionado.typePayment

          if (this.planoSelecionado.typePayment == 'CARTAO') {
            this.financialManagers.cardCvc = ""
            this.financialManagers.cardNumber = ""
            this.financialManagers.cardValidity = ""
            this.financialManagers.cardHolderName = ""
            this.financialManagers.cardFlag = ""
            this.financialManagers.formOfPayment = 'CARTAO'
          }
          
          try {
            let res = await axios.post(baseApiUrl + 'FinancialManagers/editaProposta', this.financialManagers)
            if (res.data != '') {
              this.finalizaCadastro()
            } else {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO")
            }            
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO")                
          }                       
        },

      async finalizaCadastro() {
          //PEGA O CONTRACT NUMBER S4
          try {  
            let res = await axios.post(`${baseApiUrl}FormOfPayments/firstPaymentDate`,this.formOfPayment)
            if (res.data != '') {
              this.financialManagers.contractNumberS4 = res.data.codeS4
              this.financialManagers.departamento = res.data.departamento;
              //this.salvarFinancialManager()
            } else {
              this.financialManagers.contractNumberS4 = ''
              this.financialManagers.departamento = '';
              //this.salvarFinancialManager()
            }
          } catch (error) {
            this.financialManagers.contractNumberS4 = ''
            this.financialManagers.departamento = '';
            //this.salvarFinancialManager()
          }
        
          //ATUALIZA O FINANCIAL MANAGER E SALVA O SALES
          if (this.financialManagers.contractNumberS4 != undefined) {
            try {
              await axios.post(baseApiUrl + 'FinancialManagers/editaProposta', this.financialManagers)
            } catch (error) {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao salvar o Responsável Financeiro","ERRO");
            }

            if (Object.entries(this.vendedorLink).length != 0) {
              this.Sales.brokerId = this.vendedorLink.brokerId
              this.Sales.salesmanId = this.vendedorLink.id
              try {
                let res = await axios.get(`https://api.ipify.org/?format=json`)
                if (res.data != null) {
                  this.Sales.fMIPConfirm = res.data.ip 
                  this.Sales.salesmanIPConfirm = res.data.ip 
                } else {
                  this.Sales.fMIPConfirm = '127.0.0.0' 
                  this.Sales.salesmanIPConfirm = '127.0.0.0'
                }
              } catch (error) {
                this.Sales.fMIPConfirm = '127.0.0.0' 
                this.Sales.salesmanIPConfirm = '127.0.0.0'  
              }
              this.Sales.financialManagerId = this.idUser
              this.Sales.fMConfirm = new Date().toISOString().substr(0, 10)
              this.Sales.salesmanConfirm = new Date().toISOString().substr(0, 10)
              try {
                let res = await axios.post(`${baseApiUrl}FinancialManagers/setExistSales`,this.Sales)
                if (res.data == true) {
                  if (this.planoSelecionado.typePayment == 'BOLETO') {
                    if (this.financialManagers.reteveAdesao == false && this.gatewayPagamento == 'P4X') {
                      this.imprimirBoleto()
                    }
                    setTimeout(() => {
                      this.isLoading = false
                      if (this.gatewayPagamento == 'EG') {
                        this.dialogoBoleto = true
                      } else if (this.gatewayPagamento == 'P4X') {
                        this.dialogLoading = true
                      }
                    }, 4000);
                  } else {
                    this.isLoading = false
                    if (this.gatewayPagamento == 'EG') {
                        this.dialogoBoleto = true
                      } else if (this.gatewayPagamento == 'P4X') {
                        this.dialogLoading = true
                      }
                  }
                } else {   
                  this.isLoading = false
                  if (this.gatewayPagamento == 'EG') {
                    this.dialogoBoleto = true
                  } else if (this.gatewayPagamento == 'P4X') {
                    this.dialogLoading = true
                  }
                }
              } catch (error) {
                this.isLoading = false
                vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO") 
              }
            } else {
              this.Sales.brokerId = this.brokerPlanoRiso
              this.Sales.salesmanId = this.salesmanPlanoRiso
              try {
                let res = await axios.get(`https://api.ipify.org/?format=json`)
                if (res.data != null) {
                  this.Sales.fMIPConfirm = res.data.ip 
                  this.Sales.salesmanIPConfirm = res.data.ip 
                } else {
                  this.Sales.fMIPConfirm = '127.0.0.0' 
                  this.Sales.salesmanIPConfirm = '127.0.0.0'
                }
              } catch (error) {
                this.Sales.fMIPConfirm = '127.0.0.0' 
                this.Sales.salesmanIPConfirm = '127.0.0.0'  
              }
              this.Sales.financialManagerId = this.idUser
              this.Sales.fMConfirm = new Date().toISOString().substr(0, 10)
              this.Sales.salesmanConfirm = new Date().toISOString().substr(0, 10)
              try {
                let res = await axios.post(`${baseApiUrl}FinancialManagers/setExistSales`,this.Sales)
                if (res.data == true) {
                  if (this.tipoPagamento == 'BOLETO') {
                    if (!this.financialManagers.reteveAdesao && this.gatewayPagamento == 'P4X')
                      this.imprimirBoleto()
                    setTimeout(() => {
                      this.isLoading = false
                      this.dialogLoading = true
                    }, 4000);
                  } else {
                    this.isLoading = false
                    this.dialogLoading = true
                  }
                } else {
                  this.isLoading = false
                  this.dialogLoading = true             
                  /* this.isLoading = false
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO") */  
                }             
              } catch (error) {
                this.isLoading = false
                vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO") 
              }
            }
          } else {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um erro ao capturar a forma de pagamento, tente novamente!","ERRO")  
          }
        },

        async imprimirBoleto() {
          //Baixando Boleto PDF
          try {
            let res = await axios.get(`https://p4x.srv.br/api/v1.0/boletos/${this.idBoleto}/imprimir`,{ responseType: 'arraybuffer', headers: {
                Authorization: 'Bearer ' + this.token, //the token is a variable which holds the token           
                'Content-type': 'application/pdf'
              }
            })
            if (res.data != null) {
              //Create a Blob from the PDF Stream
              const file = new Blob(
                [res.data], 
                {type: 'application/pdf'}
              );
              //Build a URL from the file
              const fileURL = URL.createObjectURL(file);
              const link = document.createElement('a');
              link.href = fileURL;
              link.setAttribute('download', 'boleto.pdf'); //or any other extension
              document.body.appendChild(link);
              link.click();
              //Open the URL on new Window
              window.open(fileURL);                           
            }              
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao imprimir boleto. Tente novamente ou entre em contato com a " + operadora.nome + "!","ERRO");
            this.close()                 
          }
        },

        openDialog() {
          this.tipoTitular = true
          this.$validator.reset()
          this.dependents = Object.assign({}, this.defaultDependents)
          this.editedIndexTitular = ''
          this.dataNascDependent = ''
          this.dependents.isHolder = true
          this.dialog = true
        },

        openDialogDependete() {
          this.selecaoPlano = this.financialManagers.plansId
          this.tipoTitular = false
          this.$validator.reset()
          this.dependents = Object.assign({}, this.defaultDependents)
          this.editedIndex = ''
          this.dataNascDependent = ''
          this.dialog = true
        },

        openDialogDelete(item) {
          this.editedIndex = item.id
          this.dependents = Object.assign({}, item)
          this.$validator.reset()
          this.dialogDelete = true
        },

        close() {
          this.dialogCartao = false
          this.dialogLoading = false
          this.dialog = false
          this.dialogDelete = false
          this.$validator.reset()          
          setTimeout(() => {
            this.modelCartao = Object.assign({}, this.defaltModelCartao)
            this.$validator.reset()
            this.usarDadosFM = true
          }, 800);
          setTimeout(() => {
            this.dependents = Object.assign({}, this.defaultDependents)
            this.editedIndex = ''
            this.editedIndexTitular = ''
            this.dataNascDependent = ''
          }, 300)
        },

        confirmaContrato() {
          this.close()
          this.$router.push({ path: '/areacliente' })
          setTimeout(() => {
            document.location.reload(true);
          }, 500);
        },

        getCardFlag(cardnumber) {
          cardnumber.replace(/[^0-9]+/g, '');
          var cards = {
            visa      : /^4[0-9]{12}(?:[0-9]{3})/,
            mastercard : /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/,
            diners    : /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
            /* amex      : /^3[47][0-9]{13}/,
            discover  : /^6(?:011|5[0-9]{2})[0-9]{12}/, */
            hipercard  : /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
            elo        : /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((6504)|(5067)|(4576)|(4011))\d{0,12})/,
            /* jcb        : /^(?:2131|1800|35\d{3})\d{11}/,        
            aura      : /^(5078\d{2})(\d{2})(\d{11})$/  */     
          };

          for (var flag in cards) {
            if (cards[flag].test(cardnumber)) {
              return flag.toUpperCase();
            }
          }        

          return false;
        },

        //CONTROLE DE ANEXOS
        inputFilter(newFile, oldFile, prevent) {
          if (newFile && !oldFile) {
            // Before adding a file
            // Filter system files or hide files
            if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
              return prevent()
            }
            // Filter php html js file
            if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
              return prevent()
            }
          }
        },
      
        inputFileRg1(newFile, oldFile) {
          if (newFile && !oldFile) {       
            var reader = new FileReader();        
            var file = this.filesRg1[0]
            //salva a base64 na variável
            reader.onloadend = function() { 
              document.getElementById("rg1").value = reader.result
            };
            //Gera base64
            reader.readAsDataURL(file.file);
            //this.files = []
          }
          if (newFile && oldFile) {
            // update
          }
          if (!newFile && oldFile) {
            // remove
          }
        },
      
        inputFileRg2(newFile, oldFile) {
          if (newFile && !oldFile) {
            var reader = new FileReader();        
            var file = this.filesRg2[0]
            //Gera base64
            reader.onloadend = function() {
              document.getElementById("rg2").value = reader.result          
            };
            reader.readAsDataURL(file.file);  
            //this.files = []  
          }
          if (newFile && oldFile) {
            // update
          }
          if (!newFile && oldFile) {
            // remove
          }
        },

        inputFileCPF(newFile, oldFile) {
          if (newFile && !oldFile) {
            var reader = new FileReader();        
            var file = this.filesCPF[0]
            //Gera base64
            reader.onloadend = function() {
              document.getElementById("cpf").value = reader.result
            }; 
            reader.readAsDataURL(file.file);  
            //this.files = []
          }
          if (newFile && oldFile) {
            // update
          }
          if (!newFile && oldFile) {
            // remove
          }
        },

        inputFileAddress(newFile, oldFile) {
          if (newFile && !oldFile) {
            var reader = new FileReader();        
            var file = this.filesAddress[0]
            //Gera base64
            reader.onloadend = function() {
              document.getElementById("address").value = reader.result
            };
            reader.readAsDataURL(file.file);
            //this.files = []
          }
          if (newFile && oldFile) {
            // update
          }
          if (!newFile && oldFile) {
            // remove
          }
        },

        inputFileOutros(newFile, oldFile) {
          if (newFile && !oldFile) {
            var reader = new FileReader();
            var file = this.filesOutros[0]
            //Gera base643
            reader.onloadend = function() {
              document.getElementById("outros").value = reader.result
            }; 
            reader.readAsDataURL(file.file);  
            //this.files = []  
          }
          if (newFile && oldFile) {
            // update
          }
          if (!newFile && oldFile) {
            // remove
          }
        },
        //FIM CONTROLE DE ANEXOS
      
        calculateAge(dobString) {
          let dataAtual = new Date();
          let anoAtual = dataAtual.getFullYear();
          let anoNascParts = dobString.split('/');
          let diaNasc = anoNascParts[0];
          let mesNasc = anoNascParts[1];
          let anoNasc = anoNascParts[2];
          let idade = anoAtual - anoNasc;
          let mesAtual = dataAtual.getMonth() + 1;
          // Caso mês atual for menor que o de nascimento, não fez aniversário ainda;
          if (mesAtual < mesNasc) {
            idade--;
          } else {
            // Estando no mês do nascimento, verifica o dia
            if (mesAtual == mesNasc) {
              if (new Date().getDate() < diaNasc ) {
                // Caso a data atual for menor que o dia de nascimento, ainda não fez aniversário
                idade--;
              }
            }
          }
          return idade;
        },

        async pegaParametrosUrl() {
          this.isLoading = true
          var params = window.location.search.substring(1).split('&');
          if (params[0] != '') {
            //Criar objeto que vai conter os parametros
            var paramArray = {};
            //Passar por todos os parametros
            for (var i=0; i<params.length; i++) {
              //Dividir os parametros chave e valor
              var param = params[i].split('=');
              //Adicionar ao objeto criado antes
              paramArray[param[0]] = param[1];
            }
            if (paramArray['plano']) {
              sessionStorage.clear()
              try {
                let res = await axios.get(`${baseApiUrl}Plans?filter[where][id]=${paramArray['plano']}`)
                if (res.data != null) {
                  this.financialManagers.plansId = paramArray['plano']                
                  this.planoSelecionado = res.data[0]
                  this.selecaoPlano = res.data[0].id
                  this.pdfSelecionado = this.planoSelecionado.urlContrato
                  this.dependents.namePlan = res.data[0].name
                  this.tipoPagamento = this.planoSelecionado.typePayment
                  }
              } catch (error) {
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao carregar informações do plano, tente novamente!","ERRO");
              }
            }
            if (paramArray['vendedor']) {
              await axios.get(`${baseApiUrl}Salesmans/infoPublico?linkSite=${paramArray['vendedor']}`).then(res => {        
                if (res.data != null) {
                  this.vendedorLink = res.data[0] 
                  this.temVendedor = true
                  this.linkVendedor = true
                  this.nomeVendedor = this.vendedorLink.linkSite
                  this.financialManagers.vendedor = this.vendedorLink.linkSite 
                  this.financialManagers.CPFVendedor =  this.vendedorLink.cpf     
                  this.financialManagers.salesmanId = this.vendedorLink.id  
                  this.financialManagers.brokerId = this.vendedorLink.brokerId        
                }
              })
            }
          }
          this.isLoading = false
        },

        async salvaValorDesconto() {
          let valorComDesconto = this.valorTotalProposta
          await this.excluiCupom()
          this.financialManagers.responsibility = this.financialManagers.modalidadePagamento == 'MENSAL' ? this.valorTotalProposta : parseFloat((this.valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*12).toFixed(2).replace(',', '.')
          this.financialManagers.valorDesconto = parseFloat(this.valorTotalProposta.replace(',','.') - valorComDesconto.replace(',','.')).toFixed(2).toString()
        },

        listenMessage() {
          var vm = this;
          window.addEventListener(
            "message",
            (event) => {
              // Ignora eventos emitidos por outras origens
              if (event.origin !== 'https://app.elosgate.com.br') {
                return;
              }

              switch(event.data.status) {
                case 0: {
                  // Pagamento concluído
                  this.dialogoPagamentoIframe = false
                  this.dialogLoading = true
                  break;
                }
                case 1001: {
                  // Token inválido ou expirado
                  vm.$refs.chamaSnackbar.snack("orange","Token inválido ou expirado, tente novamente!","ATENÇÃO")
                  break;
                }
                case 2001: {
                  // Nenhum pagamento pendente para a transação do token
                  vm.$refs.chamaSnackbar.snack("orange","Nenhum pagamento pendente para a transação do token","ATENÇÃO")
                  break;
                }
                case 3001: {
                  // Serviço indisponível
                  vm.$refs.chamaSnackbar.snack("red","Serviço indisponível temporariamente, tente novamente mais tarde","DESCULPE")
                  break;
                }
                case 3002: {
                  // Requisição inválida
                  vm.$refs.chamaSnackbar.snack("orange","Requisição inválida","ATENÇÃO")
                  break;
                }
              }
            }, false
          )
        },

        async pegaFormOfPayment(type) {
          let codeS4
          let dados = {
            "costCenterId": this.planoSelecionado.costCenterId,
            "dayInclusion": new Date().getDate(),
            "type": type,
          }

          await axios.post(baseApiUrl + 'FormOfPayments/firstPaymentDate', dados)
          .then(response => {
            if (response.data) {
              codeS4 = response.data.codeS4
            }
          })

          return codeS4
        },

        async geraNumeroProposta(financialManagerId) {
          let numProposta = false
          let numero = ''

          while (!numProposta) {
            numero = financialManagerId.replace(/[^\d]+/g,'').substr(0, 6) + Math.floor(1000 + Math.random() * 1000)

            await axios.post(baseApiUrl + 'FinancialManagers/quantidade', {"proposalNumber": numero})
            .then(response => {
              if (response.data.count == 0) {
                numProposta = true
              }
            })
          }

          return numero
        },

        async pegaIp() {
          let ip

          await axios.get('https://api.ipify.org/?format=json')
          .then(response => {
            if (response.data) { 
              ip = response.data.ip
            } else {
              ip = '127.0.0.0'
            }
          })

          return ip
        },
      },    
  }
</script>

<style>
  .v-table__overflow {
    border-radius: 10px;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
  }

  span.v-stepper__step__step.primary{
    background-color: #8395A7!important;
    border-color: #8395A7!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #8395A7;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #8395A7;
  }

  table.v-table thead tr th {
    background-color: #8395A7;
    font-size: 1rem;
  }

  .v-list__tile.theme--light{
    justify-content: center;
  }

  .centralizar {
    text-align: left;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: none;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .theme--light.v-table thead th  {
    color: white;
  }

  .theme--light.v-datatable thead th.column.sortable:hover {
    color: rgb(17, 16, 16);
  }

  .theme--light.v-datatable thead th.column.sortable.active {
    color: white;
    font-weight: bold;
  }

  table.v-table thead th:first-child, table.v-table tbody th:first-child {
    padding: 15px 24px;
  }

  .form-titulo {
    font-size: 22px;
    font-weight: 700;
    color: #8395A7;
    margin-bottom: 20px;
  }

  hr {
    border: 0;
    width: 100%;
    height: 1px;
    background-image: linear-gradient(to right,
      rgba(120, 120, 120, 0),
      rgba(120, 120, 120, 0.75),
      rgba(120, 120, 120, 0)
    );
  }

  .resumo p {
    margin-bottom: 0;
    font-size: 16px;
    line-height: 20px;
    color: #828585;
  }

  .subtotal {
    font-weight: 700;
    font-size: 20px;
    color: #828585;
  }

  .total {
    font-size: 30px;
    color: #8395A7;
    line-height: 30px;
    margin-top: 5px;
    display: block;
    font-weight: bold;
  }

  .page-content p {
    margin-bottom: 0;
  }

  .cardpag {
    background-color: #8395A7;
    color: white;
    /* color: #8395A7; */
    justify-content: center;
    font-weight: 700;
    font-size: 20px;
  }

  a {
    text-decoration: none
  }

  .imgpag {
    opacity: 0.5;
  }
</style>
